// XTREME 4X4 — Vehicle Selector DB
// Generado desde tags fit-YYYY-marca-modelo de productos activos en Shopify.
// La version "Compatible" existe para habilitar la busqueda; el filtro real usa año/marca/modelo.
window.X4DB = {
  "acura": {
    label: "Acura", collection: "acura",
    models: {
      "Cl": {
        years: [2003,2002,2001],
        versions: ["Compatible"]
      },
      "Integra": {
        years: [2001,2000,1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "Nsx": {
        years: [2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "Tsx": {
        years: [2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      }
    }
  },
  "alfa": {
    label: "Alfa", collection: "alfa",
    models: {
      "Romeo Alfetta": {
        years: [1977,1976,1975],
        versions: ["Compatible"]
      },
      "Romeo Berlina": {
        years: [1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "Romeo Duetto 1600": {
        years: [1968,1967,1966],
        versions: ["Compatible"]
      },
      "Romeo Giulia": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "Romeo Giulia Sprint": {
        years: [1966,1965,1964,1963],
        versions: ["Compatible"]
      },
      "Romeo Gt Veloce": {
        years: [1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "Romeo Gta": {
        years: [1965],
        versions: ["Compatible"]
      },
      "Romeo Gtv 6": {
        years: [1986,1985,1984,1983,1982,1981],
        versions: ["Compatible"]
      },
      "Romeo Milano": {
        years: [1989,1988,1987],
        versions: ["Compatible"]
      },
      "Romeo Montreal": {
        years: [1974,1973,1972],
        versions: ["Compatible"]
      },
      "Romeo Spider": {
        years: [1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "Romeo Sprint": {
        years: [1979,1978,1977],
        versions: ["Compatible"]
      },
      "Romeo Stelvio": {
        years: [2022,2021,2020,2019],
        versions: ["Compatible"]
      }
    }
  },
  "arctic": {
    label: "Arctic", collection: "arctic",
    models: {
      "Cat Wildcat Xx": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      }
    }
  },
  "audi": {
    label: "Audi", collection: "audi",
    models: {
      "100": {
        years: [1994,1993,1992,1991,1990,1989],
        versions: ["Compatible"]
      },
      "100 Quattro": {
        years: [1994,1993,1992,1991,1990,1989],
        versions: ["Compatible"]
      },
      "100 Series": {
        years: [1977,1976,1975,1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "200": {
        years: [1991,1990,1989],
        versions: ["Compatible"]
      },
      "200 Quattro": {
        years: [1991,1990,1989],
        versions: ["Compatible"]
      },
      "4000": {
        years: [1987,1986,1985,1984,1983,1982,1981,1980],
        versions: ["Compatible"]
      },
      "4000 Quattro": {
        years: [1987,1986,1985,1984],
        versions: ["Compatible"]
      },
      "5000": {
        years: [1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      },
      "5000 Quattro": {
        years: [1988,1987,1986],
        versions: ["Compatible"]
      },
      "80": {
        years: [1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "80 Quattro": {
        years: [1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "90": {
        years: [1995,1994,1993,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "90 Quattro": {
        years: [1995,1994,1993,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "A3": {
        years: [2024,2023,2022,2020,2019,2018,2017,2016,2015,2013,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "A3 Quattro": {
        years: [2025,2024,2023,2022,2020,2019,2018,2017,2016,2015,2013,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "A4": {
        years: [2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "A4 Allroad": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "A4 Quattro": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "A5": {
        years: [2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "A5 Quattro": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "A5 Sportback": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "A6": {
        years: [2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "A6 Quattro": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "A7 Quattro": {
        years: [2018,2017,2016,2015,2014,2013,2012],
        versions: ["Compatible"]
      },
      "A7 Sportback": {
        years: [2025,2024,2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "A8": {
        years: [1999,1998,1997],
        versions: ["Compatible"]
      },
      "A8 Quattro": {
        years: [2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997],
        versions: ["Compatible"]
      },
      "Allroad": {
        years: [2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "Cabriolet": {
        years: [1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "Coupe": {
        years: [1987,1986,1985,1984,1983,1982,1981],
        versions: ["Compatible"]
      },
      "Coupe Quattro": {
        years: [1991,1990],
        versions: ["Compatible"]
      },
      "Fox": {
        years: [1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "Q3": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Q3 Quattro": {
        years: [2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Q4 e-tron": {
        years: [2025,2024,2023,2022],
        versions: ["Compatible"]
      },
      "Q4 e-tron Sportback": {
        years: [2025,2024,2023,2022],
        versions: ["Compatible"]
      },
      "Q5": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Q5 Phev": {
        years: [2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Q5 Sportback": {
        years: [2025,2024,2023,2022,2021],
        versions: ["Compatible"]
      },
      "Q7": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "Quattro": {
        years: [1985,1984,1983],
        versions: ["Compatible"]
      },
      "RS3": {
        years: [2024,2023,2022,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "RS4": {
        years: [2008,2007],
        versions: ["Compatible"]
      },
      "RS5": {
        years: [2021,2019,2018,2015,2014,2013],
        versions: ["Compatible"]
      },
      "RS6": {
        years: [2003],
        versions: ["Compatible"]
      },
      "RS7": {
        years: [2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "S3": {
        years: [2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "S4": {
        years: [2021,2020,2019,2018,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2002,2001,2000,1994,1993,1992],
        versions: ["Compatible"]
      },
      "S5": {
        years: [2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "S5 Sportback": {
        years: [2022,2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "S6": {
        years: [2025,2024,2023,2022,2021,2020,2018,2017,2016,2015,2014,2013,2011,2010,2009,2008,2007,2003,2002,1995],
        versions: ["Compatible"]
      },
      "S7": {
        years: [2018,2017,2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "S8": {
        years: [2018,2017,2016,2015,2014,2013,2003,2002,2001],
        versions: ["Compatible"]
      },
      "SQ5": {
        years: [2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "TT": {
        years: [2009,2008,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "TT Quattro": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Tt Rs Quattro": {
        years: [2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "Tts Quattro": {
        years: [2021,2020,2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "V8 Quattro": {
        years: [1994,1993,1992,1991,1990],
        versions: ["Compatible"]
      }
    }
  },
  "austin": {
    label: "Austin", collection: "austin",
    models: {
      "Mini": {
        years: [1966,1965,1964,1963],
        versions: ["Compatible"]
      },
      "Mini 850": {
        years: [1967,1966,1965,1964,1963],
        versions: ["Compatible"]
      },
      "Mini Cooper": {
        years: [1969,1968,1967,1966,1965,1964,1963],
        versions: ["Compatible"]
      }
    }
  },
  "bmw": {
    label: "BMW", collection: "bmw",
    models: {
      "1 Series M": {
        years: [2011],
        versions: ["Compatible"]
      },
      "128i": {
        years: [2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "135i": {
        years: [2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "135is": {
        years: [2013],
        versions: ["Compatible"]
      },
      "1500": {
        years: [1964,1963,1962,1961],
        versions: ["Compatible"]
      },
      "1600": {
        years: [1971,1970,1969,1968,1967,1966,1965,1964],
        versions: ["Compatible"]
      },
      "1600 2": {
        years: [1971,1970,1969,1968,1967,1966],
        versions: ["Compatible"]
      },
      "1600ti": {
        years: [1968,1967,1966],
        versions: ["Compatible"]
      },
      "1602": {
        years: [1971,1970,1969,1968,1967],
        versions: ["Compatible"]
      },
      "1800": {
        years: [1971,1970,1969,1968,1967,1966,1965,1964,1963],
        versions: ["Compatible"]
      },
      "1800ti": {
        years: [1967,1966,1965,1964],
        versions: ["Compatible"]
      },
      "1802": {
        years: [1971],
        versions: ["Compatible"]
      },
      "2000": {
        years: [1972,1971,1970,1969,1968,1967,1966],
        versions: ["Compatible"]
      },
      "2000c": {
        years: [1970,1969,1968,1967,1966,1965],
        versions: ["Compatible"]
      },
      "2000cs": {
        years: [1970,1969,1968,1967,1966,1965],
        versions: ["Compatible"]
      },
      "2000ti": {
        years: [1971,1970,1969,1968,1967,1966],
        versions: ["Compatible"]
      },
      "2000tii": {
        years: [1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "2002": {
        years: [1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966],
        versions: ["Compatible"]
      },
      "2002ti": {
        years: [1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "2002tii": {
        years: [1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "228i": {
        years: [2016,2015,2014],
        versions: ["Compatible"]
      },
      "228i Gran Coupe": {
        years: [2024,2023,2022,2021],
        versions: ["Compatible"]
      },
      "228i Xdrive": {
        years: [2016,2015],
        versions: ["Compatible"]
      },
      "228i Xdrive Gran Coupe": {
        years: [2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "230i": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "230i Xdrive": {
        years: [2024,2023,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "2500": {
        years: [1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "2800": {
        years: [1974,1973,1972,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "2800cs": {
        years: [1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "3 0cs": {
        years: [1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "3 0csi": {
        years: [1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "3 0s": {
        years: [1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "3 0si": {
        years: [1976,1975,1971],
        versions: ["Compatible"]
      },
      "318i": {
        years: [1998,1997,1996,1995,1994,1993,1992,1991,1985,1984],
        versions: ["Compatible"]
      },
      "318is": {
        years: [1997,1996,1995,1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "318ti": {
        years: [1999,1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "320i": {
        years: [2018,2017,2016,2015,2014,2013,1983,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "320i Xdrive": {
        years: [2018,2017,2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "323ci": {
        years: [2000],
        versions: ["Compatible"]
      },
      "323i": {
        years: [2000,1999,1998],
        versions: ["Compatible"]
      },
      "323is": {
        years: [1999,1998],
        versions: ["Compatible"]
      },
      "325": {
        years: [1988,1987,1986],
        versions: ["Compatible"]
      },
      "325ci": {
        years: [2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "325e": {
        years: [1987,1986,1985,1984],
        versions: ["Compatible"]
      },
      "325es": {
        years: [1987,1986],
        versions: ["Compatible"]
      },
      "325i": {
        years: [2006,2005,2004,2003,2002,2001,1995,1994,1993,1992,1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "325is": {
        years: [1995,1994,1993,1992,1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "325ix": {
        years: [1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "325xi": {
        years: [2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "328ci": {
        years: [2000],
        versions: ["Compatible"]
      },
      "328d": {
        years: [2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "328d Xdrive": {
        years: [2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "328i": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "328i Gt Xdrive": {
        years: [2016,2015,2014],
        versions: ["Compatible"]
      },
      "328i Xdrive": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "328is": {
        years: [1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "328xi": {
        years: [2008,2007],
        versions: ["Compatible"]
      },
      "330ci": {
        years: [2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "330e": {
        years: [2024,2023,2022,2021,2018,2017,2016],
        versions: ["Compatible"]
      },
      "330e Xdrive": {
        years: [2024,2023,2022,2021],
        versions: ["Compatible"]
      },
      "330i": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "330i Gt Xdrive": {
        years: [2019,2018,2017],
        versions: ["Compatible"]
      },
      "330i Xdrive": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "330xi": {
        years: [2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "335d": {
        years: [2011,2010,2009],
        versions: ["Compatible"]
      },
      "335i": {
        years: [2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "335i Gt Xdrive": {
        years: [2016,2015,2014],
        versions: ["Compatible"]
      },
      "335i Xdrive": {
        years: [2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "335is": {
        years: [2013,2012,2011],
        versions: ["Compatible"]
      },
      "335xi": {
        years: [2008,2007],
        versions: ["Compatible"]
      },
      "340i": {
        years: [2018,2017,2016],
        versions: ["Compatible"]
      },
      "340i Gt Xdrive": {
        years: [2019,2018,2017],
        versions: ["Compatible"]
      },
      "340i Xdrive": {
        years: [2018,2017,2016],
        versions: ["Compatible"]
      },
      "428i": {
        years: [2016,2015,2014],
        versions: ["Compatible"]
      },
      "428i Gran Coupe": {
        years: [2016,2015],
        versions: ["Compatible"]
      },
      "428i Xdrive": {
        years: [2016,2015,2014],
        versions: ["Compatible"]
      },
      "428i Xdrive Gran Coupe": {
        years: [2016,2015],
        versions: ["Compatible"]
      },
      "430i": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "430i Gran Coupe": {
        years: [2025,2024,2023,2022,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "430i Xdrive": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "430i Xdrive Gran Coupe": {
        years: [2025,2024,2023,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "435i": {
        years: [2016,2015,2014],
        versions: ["Compatible"]
      },
      "435i Gran Coupe": {
        years: [2016,2015],
        versions: ["Compatible"]
      },
      "435i Xdrive": {
        years: [2016,2015,2014],
        versions: ["Compatible"]
      },
      "435i Xdrive Gran Coupe": {
        years: [2016,2015],
        versions: ["Compatible"]
      },
      "440i": {
        years: [2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "440i Gran Coupe": {
        years: [2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "440i Xdrive": {
        years: [2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "440i Xdrive Gran Coupe": {
        years: [2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "524td": {
        years: [1986,1985],
        versions: ["Compatible"]
      },
      "525i": {
        years: [2007,2006,2005,2004,2003,2002,2001,1995,1994,1993,1992,1991,1990,1989],
        versions: ["Compatible"]
      },
      "525it": {
        years: [1993],
        versions: ["Compatible"]
      },
      "525xi": {
        years: [2007,2006],
        versions: ["Compatible"]
      },
      "528e": {
        years: [1988,1987,1986,1985,1984,1983,1982],
        versions: ["Compatible"]
      },
      "528i": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009,2008,2000,1999,1998,1997,1981,1980,1979],
        versions: ["Compatible"]
      },
      "528i Xdrive": {
        years: [2016,2015,2014,2013,2012,2010,2009],
        versions: ["Compatible"]
      },
      "528xi": {
        years: [2008],
        versions: ["Compatible"]
      },
      "530e": {
        years: [2023,2022,2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "530e Xdrive": {
        years: [2023,2022,2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "530i": {
        years: [2023,2022,2021,2020,2019,2018,2017,2007,2006,2005,2004,2003,2002,2001,1995,1994,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "530i Xdrive": {
        years: [2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "530xi": {
        years: [2007,2006],
        versions: ["Compatible"]
      },
      "533i": {
        years: [1984,1983],
        versions: ["Compatible"]
      },
      "535d": {
        years: [2016,2015,2014],
        versions: ["Compatible"]
      },
      "535d Xdrive": {
        years: [2016,2015,2014],
        versions: ["Compatible"]
      },
      "535i": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009,2008,1993,1992,1991,1990,1989,1988,1987,1986,1985],
        versions: ["Compatible"]
      },
      "535i Gt": {
        years: [2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "535i Gt Xdrive": {
        years: [2017,2016,2015,2014,2013,2012,2011],
        versions: ["Compatible"]
      },
      "535i Xdrive": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "535is": {
        years: [1988],
        versions: ["Compatible"]
      },
      "535xi": {
        years: [2008],
        versions: ["Compatible"]
      },
      "540d Xdrive": {
        years: [2018],
        versions: ["Compatible"]
      },
      "540i": {
        years: [2023,2022,2021,2020,2019,2018,2017,2003,2002,2001,2000,1999,1998,1997,1995,1994],
        versions: ["Compatible"]
      },
      "540i Xdrive": {
        years: [2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "545i": {
        years: [2005,2004],
        versions: ["Compatible"]
      },
      "550i": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "550i Gt": {
        years: [2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "550i Gt Xdrive": {
        years: [2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "550i Xdrive": {
        years: [2016,2015,2014,2013,2012,2011],
        versions: ["Compatible"]
      },
      "630csi": {
        years: [1978],
        versions: ["Compatible"]
      },
      "633csi": {
        years: [1984,1983,1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      },
      "635csi": {
        years: [1989,1988,1987,1986,1985],
        versions: ["Compatible"]
      },
      "640i": {
        years: [2018,2017,2016,2015,2014,2013,2012],
        versions: ["Compatible"]
      },
      "640i Gran Coupe": {
        years: [2019,2018,2017,2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "640i Xdrive": {
        years: [2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "640i Xdrive Gran Coupe": {
        years: [2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "640i Xdrive Gran Turismo": {
        years: [2019,2018],
        versions: ["Compatible"]
      },
      "645ci": {
        years: [2005,2004],
        versions: ["Compatible"]
      },
      "650i": {
        years: [2018,2017,2016,2015,2014,2013,2012,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "650i Gran Coupe": {
        years: [2019,2018,2017,2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "650i Xdrive": {
        years: [2018,2017,2016,2015,2014,2013,2012],
        versions: ["Compatible"]
      },
      "650i Xdrive Gran Coupe": {
        years: [2019,2018,2017,2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "733i": {
        years: [1984,1983,1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      },
      "735i": {
        years: [1992,1991,1990,1989,1988,1987,1986,1985],
        versions: ["Compatible"]
      },
      "735il": {
        years: [1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "740i": {
        years: [2001,2000,1999,1998,1997,1995,1994,1993],
        versions: ["Compatible"]
      },
      "740il": {
        years: [2001,2000,1999,1998,1997,1996,1995,1994,1993],
        versions: ["Compatible"]
      },
      "745i": {
        years: [2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "745li": {
        years: [2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "750i": {
        years: [2008,2007,2006],
        versions: ["Compatible"]
      },
      "750il": {
        years: [2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "750li": {
        years: [2008,2007,2006],
        versions: ["Compatible"]
      },
      "760i": {
        years: [2006,2005,2004],
        versions: ["Compatible"]
      },
      "760li": {
        years: [2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "840ci": {
        years: [1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "850ci": {
        years: [1997,1996,1995,1994,1993],
        versions: ["Compatible"]
      },
      "850csi": {
        years: [1995,1994],
        versions: ["Compatible"]
      },
      "850i": {
        years: [1992,1991],
        versions: ["Compatible"]
      },
      "Activehybrid 3": {
        years: [2015,2014,2013],
        versions: ["Compatible"]
      },
      "Activehybrid 5": {
        years: [2016,2015,2014,2013,2012],
        versions: ["Compatible"]
      },
      "Alpina B7": {
        years: [2008,2007],
        versions: ["Compatible"]
      },
      "Bavaria": {
        years: [1974,1973,1972],
        versions: ["Compatible"]
      },
      "I3": {
        years: [2021,2020,2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "I4": {
        years: [2025,2024,2023,2022],
        versions: ["Compatible"]
      },
      "L6": {
        years: [1987],
        versions: ["Compatible"]
      },
      "M2": {
        years: [2025,2024,2023,2021,2020,2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "M235I": {
        years: [2016,2015,2014],
        versions: ["Compatible"]
      },
      "M235I Xdrive": {
        years: [2016,2015],
        versions: ["Compatible"]
      },
      "M235I Xdrive Gran Coupe": {
        years: [2022,2021,2020],
        versions: ["Compatible"]
      },
      "M240I": {
        years: [2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "M240I Xdrive": {
        years: [2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "M3": {
        years: [2025,2024,2023,2022,2021,2018,2017,2016,2015,2013,2012,2011,2010,2009,2008,2006,2005,2004,2003,2002,2001,1999,1998,1997,1996,1995,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "M340I": {
        years: [2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "M340I Xdrive": {
        years: [2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "M4": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "M440I": {
        years: [2025,2024,2023,2022,2021],
        versions: ["Compatible"]
      },
      "M440I Gran Coupe": {
        years: [2025],
        versions: ["Compatible"]
      },
      "M440I Xdrive": {
        years: [2025,2024,2023,2022,2021],
        versions: ["Compatible"]
      },
      "M440I Xdrive Gran Coupe": {
        years: [2025,2024,2023,2022],
        versions: ["Compatible"]
      },
      "M5": {
        years: [2010,2009,2008,2007,2006,2003,2002,2001,2000,1993,1992,1991,1988],
        versions: ["Compatible"]
      },
      "M550I Xdrive": {
        years: [2023,2022,2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "M6": {
        years: [2010,2009,2008,2007,2006,1988,1987],
        versions: ["Compatible"]
      },
      "X1": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012],
        versions: ["Compatible"]
      },
      "X2": {
        years: [2023,2022,2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "X3": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "X4": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "X5": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "X6": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "Z3": {
        years: [2002,2001,2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "Z4": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      }
    }
  },
  "bentley": {
    label: "Bentley", collection: "bentley",
    models: {
      "Continental": {
        years: [2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993],
        versions: ["Compatible"]
      },
      "Flying Spur": {
        years: [2018,2017,2016,2015,2014,2013],
        versions: ["Compatible"]
      }
    }
  },
  "buick": {
    label: "Buick", collection: "buick",
    models: {
      "Century": {
        years: [1981,1980,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "Commercial Chassis": {
        years: [1995,1994,1993,1992],
        versions: ["Compatible"]
      },
      "Electra": {
        years: [1984,1983,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "Enclave": {
        years: [2017,2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "Envision": {
        years: [2020,2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "Estate Wagon": {
        years: [1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Lacrosse": {
        years: [2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Lesabre": {
        years: [1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "Rainier": {
        years: [2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "Regal": {
        years: [2017,2016,2015,2014,2013,2012,2011,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Roadmaster": {
        years: [1996,1995,1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "Skylark": {
        years: [1967,1966,1965,1964],
        versions: ["Compatible"]
      },
      "Special": {
        years: [1967,1966,1965,1964],
        versions: ["Compatible"]
      }
    }
  },
  "cadillac": {
    label: "Cadillac", collection: "cadillac",
    models: {
      "Brougham": {
        years: [1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "Catera": {
        years: [2001,2000,1999,1998,1997],
        versions: ["Compatible"]
      },
      "Deville": {
        years: [1984,1983,1982,1981,1980],
        versions: ["Compatible"]
      },
      "Escalade": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2000,1999],
        versions: ["Compatible"]
      },
      "Escalade Esv": {
        years: [2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "Escalade Ext": {
        years: [2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Fleetwood": {
        years: [1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980],
        versions: ["Compatible"]
      },
      "Seville": {
        years: [1979,1978,1977,1976],
        versions: ["Compatible"]
      }
    }
  },
  "can-am": {
    label: "Can-Am", collection: "can-am",
    models: {
      "Commander": {
        years: [2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Defender": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Defender Max": {
        years: [2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Maverick": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2011],
        versions: ["Compatible"]
      },
      "Maverick R": {
        years: [2026,2025,2024],
        versions: ["Compatible"]
      },
      "Maverick R X": {
        years: [2024],
        versions: ["Compatible"]
      },
      "Maverick R X Rs": {
        years: [2024],
        versions: ["Compatible"]
      },
      "Maverick R X Rs Smart Shox": {
        years: [2024],
        versions: ["Compatible"]
      },
      "Maverick Sport": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Maverick X3": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "Maverick X3 Max Rs Turbo R": {
        years: [2021,2020],
        versions: ["Compatible"]
      },
      "Maverick X3 Max Rs Turbo Rr": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "Maverick X3 Max Turbo": {
        years: [2020,2019,2018],
        versions: ["Compatible"]
      },
      "Maverick X3 Max Turbo R": {
        years: [2019,2018,2017],
        versions: ["Compatible"]
      },
      "Maverick X3 Max X Mr Turbo Rr": {
        years: [2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Maverick X3 Max X Rs Turbo R": {
        years: [2019,2018,2017],
        versions: ["Compatible"]
      },
      "Maverick X3 Max X Rs Turbo Rr": {
        years: [2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Maverick X3 Max X Rs Turbo Rr Smart Shox": {
        years: [2024,2023,2022,2021],
        versions: ["Compatible"]
      },
      "Maverick X3 Rs Turbo R": {
        years: [2021,2020],
        versions: ["Compatible"]
      },
      "Maverick X3 Rs Turbo Rr": {
        years: [2023,2022],
        versions: ["Compatible"]
      },
      "Maverick X3 X Mr Turbo R": {
        years: [2019,2018],
        versions: ["Compatible"]
      },
      "Maverick X3 X Mr Turbo Rr": {
        years: [2022,2021,2020],
        versions: ["Compatible"]
      },
      "Maverick X3 X Mr Turbo Rr 72": {
        years: [2023,2022],
        versions: ["Compatible"]
      },
      "Maverick X3 X Rc Turbo R": {
        years: [2019,2018],
        versions: ["Compatible"]
      },
      "Maverick X3 X Rc Turbo Rr": {
        years: [2022,2021,2020],
        versions: ["Compatible"]
      },
      "Maverick X3 X Rc Turbo Rr 72": {
        years: [2023,2022],
        versions: ["Compatible"]
      },
      "Maverick X3 X Rs Turbo R": {
        years: [2019,2018,2017],
        versions: ["Compatible"]
      },
      "Maverick X3 X Rs Turbo Rr": {
        years: [2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Maverick X3 X Rs Turbo Rr Smart Shox": {
        years: [2023,2022,2021],
        versions: ["Compatible"]
      },
      "Outlander": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Renegade": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012,2011],
        versions: ["Compatible"]
      }
    }
  },
  "chevrolet": {
    label: "Chevrolet", collection: "chevrolet",
    models: {
      "Astro": {
        years: [2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985],
        versions: ["Compatible"]
      },
      "Avalanche": {
        years: [2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "Avalanche 1500": {
        years: [2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Avalanche 2500": {
        years: [2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Bel Air": {
        years: [1957,1956,1955],
        versions: ["Compatible"]
      },
      "Blazer": {
        years: [2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "C10": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "C10 Pickup": {
        years: [1974,1973,1972,1971,1970,1969,1968,1967],
        versions: ["Compatible"]
      },
      "C10 Suburban": {
        years: [1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "C1500": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "C1500 Suburban": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992],
        versions: ["Compatible"]
      },
      "C20": {
        years: [1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "C20 Pickup": {
        years: [1974,1973,1972,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "C20 Suburban": {
        years: [1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "C25": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "C2500": {
        years: [2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "C2500 Suburban": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992],
        versions: ["Compatible"]
      },
      "C30": {
        years: [1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "C30 Pickup": {
        years: [1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "C3500": {
        years: [2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "C3500hd": {
        years: [1998,1997,1996,1995,1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "C4500 Kodiak": {
        years: [2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "C5500 Kodiak": {
        years: [2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "Camaro": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967],
        versions: ["Compatible"]
      },
      "Caprice": {
        years: [1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1972,1971,1970,1969,1968,1967,1966],
        versions: ["Compatible"]
      },
      "Chevelle": {
        years: [1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964],
        versions: ["Compatible"]
      },
      "Chevy Ii": {
        years: [1968],
        versions: ["Compatible"]
      },
      "Cobalt": {
        years: [2010,2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "Colorado": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2012,2011,2010,2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "Corvette": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962,1961,1960,1959,1958,1957,1956,1955,1954,1953],
        versions: ["Compatible"]
      },
      "Cruze": {
        years: [2015,2014,2013,2012,2011],
        versions: ["Compatible"]
      },
      "Cruze Limited": {
        years: [2016],
        versions: ["Compatible"]
      },
      "El Camino": {
        years: [1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "Express 1500": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "Express 2500": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "Express 3500": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "Express 4500": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "G10": {
        years: [1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "G10 Van": {
        years: [1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "G20": {
        years: [1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "G20 Van": {
        years: [1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "G30": {
        years: [1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "G30 Van": {
        years: [1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "Hhr": {
        years: [2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "Impala": {
        years: [1996,1995,1994,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "K10": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "K10 Pickup": {
        years: [1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "K10 Suburban": {
        years: [1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "K1500": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "K1500 Suburban": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992],
        versions: ["Compatible"]
      },
      "K20": {
        years: [2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "K20 Pickup": {
        years: [1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "K20 Suburban": {
        years: [1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "K25": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "K2500": {
        years: [2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "K2500 Suburban": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992],
        versions: ["Compatible"]
      },
      "K30": {
        years: [2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "K30 Pickup": {
        years: [1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "K3500": {
        years: [2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "K5 Blazer": {
        years: [1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Malibu": {
        years: [2015,2014,2013,1983,1982,1981,1980,1979,1978,1975],
        versions: ["Compatible"]
      },
      "Malibu Limited": {
        years: [2016],
        versions: ["Compatible"]
      },
      "Monte Carlo": {
        years: [1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "Nova": {
        years: [1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "P10": {
        years: [1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "P10 Series": {
        years: [1967,1966,1965,1964,1963],
        versions: ["Compatible"]
      },
      "P10 Van": {
        years: [1974,1973,1972,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "P20": {
        years: [1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "P20 Van": {
        years: [1974,1973],
        versions: ["Compatible"]
      },
      "P30": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "P30 Van": {
        years: [1974,1973],
        versions: ["Compatible"]
      },
      "R10": {
        years: [1987],
        versions: ["Compatible"]
      },
      "R10 Suburban": {
        years: [1988,1987],
        versions: ["Compatible"]
      },
      "R1500 Suburban": {
        years: [1991,1990,1989],
        versions: ["Compatible"]
      },
      "R20": {
        years: [1988,1987],
        versions: ["Compatible"]
      },
      "R20 Suburban": {
        years: [1988,1987],
        versions: ["Compatible"]
      },
      "R2500": {
        years: [1989],
        versions: ["Compatible"]
      },
      "R2500 Suburban": {
        years: [1991,1990,1989],
        versions: ["Compatible"]
      },
      "R30": {
        years: [1988,1987],
        versions: ["Compatible"]
      },
      "R3500": {
        years: [1991,1990,1989],
        versions: ["Compatible"]
      },
      "S10": {
        years: [2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982],
        versions: ["Compatible"]
      },
      "S10 Blazer": {
        years: [1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983],
        versions: ["Compatible"]
      },
      "Silverado 1500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "Silverado 1500 Classic": {
        years: [2007],
        versions: ["Compatible"]
      },
      "Silverado 1500 HD": {
        years: [2006,2005,2003,2002,2001],
        versions: ["Compatible"]
      },
      "Silverado 1500 Ld": {
        years: [2019],
        versions: ["Compatible"]
      },
      "Silverado 1500 Ltd": {
        years: [2022],
        versions: ["Compatible"]
      },
      "Silverado 2500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "Silverado 2500 HD": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "Silverado 2500 HD Classic": {
        years: [2007],
        versions: ["Compatible"]
      },
      "Silverado 3500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "Silverado 3500 Classic": {
        years: [2007],
        versions: ["Compatible"]
      },
      "Silverado 3500 HD": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "Ssr": {
        years: [2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "Suburban": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "Suburban 1500": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Suburban 2500": {
        years: [2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Tahoe": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992],
        versions: ["Compatible"]
      },
      "Trailblazer": {
        years: [2009,2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Trailblazer Ext": {
        years: [2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Traverse": {
        years: [2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Two Ten Series": {
        years: [1957,1956,1955],
        versions: ["Compatible"]
      },
      "V10": {
        years: [1987],
        versions: ["Compatible"]
      },
      "V10 Suburban": {
        years: [1988,1987],
        versions: ["Compatible"]
      },
      "V1500 Suburban": {
        years: [1991,1990,1989],
        versions: ["Compatible"]
      },
      "V20": {
        years: [1987],
        versions: ["Compatible"]
      },
      "V20 Suburban": {
        years: [1988,1987],
        versions: ["Compatible"]
      },
      "V2500 Suburban": {
        years: [1991,1990,1989],
        versions: ["Compatible"]
      },
      "V3500": {
        years: [1991,1990,1989],
        versions: ["Compatible"]
      },
      "Volt": {
        years: [2015,2014,2013,2012,2011],
        versions: ["Compatible"]
      }
    }
  },
  "chevrolet-gmc": {
    label: "Chevrolet / GMC", collection: "chevrolet-gmc",
    models: {
      "Avalanche": {
        years: [2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Blazer 4wd": {
        years: [1973],
        versions: ["Compatible"]
      },
      "C/K 1500": {
        years: [1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "C/K 2500": {
        years: [1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "C/K 3500": {
        years: [1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "C10": {
        years: [1977],
        versions: ["Compatible"]
      },
      "C10 Pickup": {
        years: [1960],
        versions: ["Compatible"]
      },
      "C15": {
        years: [1977],
        versions: ["Compatible"]
      },
      "C1500": {
        years: [1988],
        versions: ["Compatible"]
      },
      "C20 Pickup": {
        years: [1960],
        versions: ["Compatible"]
      },
      "C30": {
        years: [1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "Canyon": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2005,2004],
        versions: ["SL Regular Cab","SLE Regular Cab","Elevation Crew Cab","SLT Crew Cab","AT4 Crew Cab","Denali Crew Cab","AT4X Crew Cab"]
      },
      "Colorado": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2005,2004],
        versions: ["WT Regular Cab","WT Extended Cab","WT Crew Cab","LT Extended Cab","LT Crew Cab","Z71 Crew Cab","Trail Boss Crew Cab","ZR2 Crew Cab"]
      },
      "Jimmy": {
        years: [1973],
        versions: ["Compatible"]
      },
      "Jimmy 4wd": {
        years: [1973],
        versions: ["Compatible"]
      },
      "K10": {
        years: [1977,1973,1967],
        versions: ["Compatible"]
      },
      "K10 Pickup": {
        years: [1973,1967],
        versions: ["Compatible"]
      },
      "K10 Pickup 4wd": {
        years: [1973,1967],
        versions: ["Compatible"]
      },
      "K15": {
        years: [1977],
        versions: ["Compatible"]
      },
      "K15 K1500 Pickup": {
        years: [1973,1967],
        versions: ["Compatible"]
      },
      "K1500": {
        years: [1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "K20": {
        years: [1967],
        versions: ["Compatible"]
      },
      "K20 Pickup 4wd": {
        years: [1973],
        versions: ["Compatible"]
      },
      "K25 K2500 Pickup": {
        years: [1970,1969],
        versions: ["Compatible"]
      },
      "K2500": {
        years: [1988],
        versions: ["Compatible"]
      },
      "K30": {
        years: [1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "K3500": {
        years: [1988],
        versions: ["Compatible"]
      },
      "S10 / S15 / Blazer / Sonoma": {
        years: [2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982],
        versions: ["S10 Regular Cab 4WD","S10 Extended Cab 4WD","Blazer 4WD","S10 Regular Cab RWD","S10 Extended Cab RWD","Blazer RWD","S15 4WD","Sonoma 4WD","Sonoma RWD","ZR2","Highrider"]
      },
      "S10 Blazer": {
        years: [1984,1983],
        versions: ["Compatible"]
      },
      "S15 Jimmy": {
        years: [1983],
        versions: ["Compatible"]
      },
      "Sierra 1500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Pro Regular Cab","Pro Double Cab","SLE Regular Cab","SLE Double Cab","SLE Crew Cab","Elevation Crew Cab","SLT Double Cab","SLT Crew Cab","AT4 Double Cab","AT4 Crew Cab","AT4X Crew Cab","Denali Crew Cab","Denali Ultimate Crew Cab"]
      },
      "Sierra 2500 All All All All Rear 4 6": {
        years: [1999],
        versions: ["Compatible"]
      },
      "Sierra 2500 HD": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "Sierra 3500 HD": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "Silverado 1500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["WT Regular Cab","WT Double Cab","WT Crew Cab","Custom Double Cab","Custom Crew Cab","LT Double Cab","LT Crew Cab","RST Crew Cab","LTZ Crew Cab","High Country Crew Cab","Trail Boss Double Cab","Trail Boss Crew Cab","ZR2 Crew Cab"]
      },
      "Silverado 2500 All All All All Rear 4 6": {
        years: [1999],
        versions: ["Compatible"]
      },
      "Silverado 2500 HD": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "Silverado 3500 HD": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "Suburban": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1969],
        versions: ["LS 4WD","LT 4WD","RST 4WD","Z71 4WD","LTZ 4WD","High Country 4WD","LS RWD","LT RWD"]
      },
      "Tahoe": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["LS 4WD","LT 4WD","RST 4WD","Z71 4WD","LTZ 4WD","High Country 4WD","LS RWD","LT RWD"]
      },
      "Yukon / Yukon XL": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["SLE 4WD","SLT 4WD","AT4 4WD","Denali 4WD","Denali Ultimate 4WD","SLE RWD","SLT RWD"]
      }
    }
  },
  "chrysler": {
    label: "Chrysler", collection: "chrysler",
    models: {
      "300": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "Aspen": {
        years: [2009,2008,2007],
        versions: ["Compatible"]
      },
      "Crossfire": {
        years: [2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "Grand Voyager": {
        years: [2000],
        versions: ["Compatible"]
      },
      "Town And Country": {
        years: [2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990],
        versions: ["Compatible"]
      },
      "Voyager": {
        years: [2003,2002,2001,2000],
        versions: ["Compatible"]
      }
    }
  },
  "daihatsu": {
    label: "Daihatsu", collection: "daihatsu",
    models: {
      "Hijet": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      }
    }
  },
  "dodge": {
    label: "Dodge", collection: "dodge",
    models: {
      "B100": {
        years: [1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "B100 Van": {
        years: [1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "B150": {
        years: [1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981],
        versions: ["Compatible"]
      },
      "B1500": {
        years: [1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "B200": {
        years: [1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "B200 Van": {
        years: [1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "B250": {
        years: [1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981],
        versions: ["Compatible"]
      },
      "B2500": {
        years: [1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "B300": {
        years: [1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "B300 Van": {
        years: [1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "B350": {
        years: [1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981],
        versions: ["Compatible"]
      },
      "B3500": {
        years: [1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "Caravan": {
        years: [2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984],
        versions: ["Compatible"]
      },
      "Challenger": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "Charger": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "D100": {
        years: [1989,1988,1987,1986,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "D150": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "D200": {
        years: [1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "D250": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981],
        versions: ["Compatible"]
      },
      "D300": {
        years: [1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "D300 Pickup": {
        years: [1974,1973,1972],
        versions: ["Compatible"]
      },
      "D350": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981],
        versions: ["Compatible"]
      },
      "D50": {
        years: [1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "Dakota": {
        years: [2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997],
        versions: ["Compatible"]
      },
      "Durango": {
        years: [2015,2014,2013,2012,2011,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "Grand Caravan": {
        years: [2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "Magnum": {
        years: [2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "Nitro": {
        years: [2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "RAM 1500": {
        years: [2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "RAM 1500 Van": {
        years: [2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "RAM 2500": {
        years: [2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "RAM 2500 Van": {
        years: [2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "RAM 3500": {
        years: [2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "RAM 3500 Van": {
        years: [2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "RAM 50": {
        years: [1991,1990,1989,1988,1987,1986,1985,1984,1983],
        versions: ["Compatible"]
      },
      "Raider": {
        years: [1989,1988,1987],
        versions: ["Compatible"]
      },
      "Ramcharger": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962,1961,1960],
        versions: ["Compatible"]
      },
      "Sprinter 2500": {
        years: [2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "Sprinter 3500": {
        years: [2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "W100": {
        years: [1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962,1961,1960],
        versions: ["Compatible"]
      },
      "W100 Pickup": {
        years: [1974,1973,1972],
        versions: ["Compatible"]
      },
      "W150": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "W200": {
        years: [1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "W200 Pickup": {
        years: [1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "W250": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      },
      "W300": {
        years: [1980,1979,1978,1977,1976,1975,1974],
        versions: ["Compatible"]
      },
      "W300 Pickup": {
        years: [1974,1973,1972],
        versions: ["Compatible"]
      },
      "W350": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      }
    }
  },
  "fiat": {
    label: "Fiat", collection: "fiat",
    models: {
      "124 Spider": {
        years: [2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "500": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012],
        versions: ["Compatible"]
      },
      "500x": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016],
        versions: ["Compatible"]
      }
    }
  },
  "ford": {
    label: "Ford", collection: "ford",
    models: {
      "Bronco": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1960,1959],
        versions: ["Base 2 Puertas","Big Bend 2 Puertas","Black Diamond 2 Puertas","Outer Banks 2 Puertas","Badlands 2 Puertas","Wildtrak 2 Puertas","Everglades 2 Puertas","Raptor 2 Puertas","Base 4 Puertas","Big Bend 4 Puertas","Black Diamond 4 Puertas","Outer Banks 4 Puertas","Badlands 4 Puertas","Wildtrak 4 Puertas","Everglades 4 Puertas","Raptor 4 Puertas","Heritage Edition","Heritage Limited Edition"]
      },
      "Bronco Ii": {
        years: [1990,1989,1988,1987,1986,1985,1984],
        versions: ["Compatible"]
      },
      "Bronco Sport": {
        years: [2026,2025,2024,2023,2022,2021],
        versions: ["Base","Big Bend","Outer Banks","Badlands","Heritage"]
      },
      "C Max": {
        years: [2018,2017,2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "Crown Victoria": {
        years: [2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992],
        versions: ["Compatible"]
      },
      "Custom 500": {
        years: [1977,1976,1975],
        versions: ["Compatible"]
      },
      "E-100 Econoline": {
        years: [1983,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "E-100 Econoline Club Wagon": {
        years: [1983,1975],
        versions: ["Compatible"]
      },
      "E-150": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "E-150 Club Wagon": {
        years: [2005,2004,2003],
        versions: ["Compatible"]
      },
      "E-150 Econoline": {
        years: [2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "E-150 Econoline Club Wagon": {
        years: [2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "E-200 Econoline": {
        years: [1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "E-250": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "E-250 Econoline": {
        years: [2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "E-250 Econoline Club Wagon": {
        years: [1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "E-350 Club Wagon": {
        years: [2005,2004,2003],
        versions: ["Compatible"]
      },
      "E-350 Econoline": {
        years: [1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "E-350 Econoline Club Wagon": {
        years: [2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "E-350 Super Duty": {
        years: [2023,2022,2021,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "E-450 Econoline Super Duty": {
        years: [2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "E-450 Super Duty": {
        years: [2023,2022,2021,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "E-550 Econoline Super Duty": {
        years: [2002],
        versions: ["Compatible"]
      },
      "E-550 Super Duty": {
        years: [2003],
        versions: ["Compatible"]
      },
      "Ecosport": {
        years: [2022,2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "Edge": {
        years: [2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "Escape": {
        years: [2019,2018,2017,2016,2015,2014,2013,2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "Excursion": {
        years: [2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Expedition": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997],
        versions: ["XLT","Eddie Bauer","Limited","King Ranch","Max"]
      },
      "Explorer": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991],
        versions: ["Base","XLT","Limited","Sport","Platinum"]
      },
      "Explorer Sport": {
        years: [2003,2002,2001],
        versions: ["Compatible"]
      },
      "Explorer Sport Trac": {
        years: [2010,2009,2008,2007,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "F-100": {
        years: [1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1959],
        versions: ["Compatible"]
      },
      "F-100 4wd": {
        years: [1974,1973,1972,1971,1970,1966,1965],
        versions: ["Compatible"]
      },
      "F-150": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1959],
        versions: ["XL Regular Cab","XL SuperCab","XL SuperCrew","XLT Regular Cab","XLT SuperCab","XLT SuperCrew","Lariat SuperCab","Lariat SuperCrew","King Ranch","Platinum","Limited","Raptor","Raptor R","Tremor","Lightning","FX4","Harley-Davidson"]
      },
      "F-150 Heritage": {
        years: [2004],
        versions: ["Compatible"]
      },
      "F-250": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962,1961],
        versions: ["Compatible"]
      },
      "F-250 HD": {
        years: [1997],
        versions: ["Compatible"]
      },
      "F-250 Super Duty": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1959],
        versions: ["XL Regular Cab","XL SuperCab","XL Crew Cab","XLT Regular Cab","XLT SuperCab","XLT Crew Cab","Lariat","King Ranch","Platinum","Limited","Tremor","Harley-Davidson"]
      },
      "F-350": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962,1961],
        versions: ["Compatible"]
      },
      "F-350 Super Duty": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978],
        versions: ["XL Regular Cab","XL SuperCab","XL Crew Cab","XLT Regular Cab","XLT SuperCab","XLT Crew Cab","Lariat","King Ranch","Platinum","Limited","Tremor"]
      },
      "F-450 Super Duty": {
        years: [2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "F-53 Motorhome Chassis": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2004,2003,2002,2001,2000,1999,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "F-550 Super Duty": {
        years: [2022,2021,2020,2019,2018,2017,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "F-59 Commercial Stripped Chassis": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011],
        versions: ["Compatible"]
      },
      "Fairmont": {
        years: [1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      },
      "Fiesta": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012,2011],
        versions: ["Compatible"]
      },
      "Fiesta St": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Focus": {
        years: [2018,2017,2016,2015,2014,2013,2012,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Fusion": {
        years: [2020,2019,2018,2017,2016,2015,2014,2013,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "Gran Torino": {
        years: [1976,1975],
        versions: ["Compatible"]
      },
      "Granada": {
        years: [1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "Ltd": {
        years: [1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Ltd Crown Victoria": {
        years: [1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "Ltd Ii": {
        years: [1979,1978,1977],
        versions: ["Compatible"]
      },
      "Maverick": {
        years: [2026,2025,2024,2023,2022,1977],
        versions: ["Compatible"]
      },
      "Mustang": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "Mustang Ii": {
        years: [1978,1977,1976,1975,1974],
        versions: ["Compatible"]
      },
      "Police Interceptor Utility": {
        years: [2018,2017,2016],
        versions: ["Compatible"]
      },
      "Ranchero": {
        years: [1979,1978,1977,1976,1975,1974,1973,1972],
        versions: ["Compatible"]
      },
      "Ranger": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983],
        versions: ["Compatible"]
      },
      "Ranger (Americana)": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019],
        versions: ["XL","XLT","Lariat","Tremor","Raptor"]
      },
      "Ranger (Argentina/México)": {
        years: [2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998],
        versions: ["XL Regular Cab","XL SuperCab","XLT Regular Cab","XLT SuperCab","Tremor 4WD"]
      },
      "Ranger Argentina Mexico": {
        years: [2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "Thunderbird": {
        years: [1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967],
        versions: ["Compatible"]
      },
      "Torino": {
        years: [1976,1975],
        versions: ["Compatible"]
      },
      "Transit 150": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Transit 250": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Transit 350": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Transit 350 HD": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Transit Connect": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      }
    }
  },
  "foretravel": {
    label: "Foretravel", collection: "foretravel",
    models: {
      "Motorhome U270": {
        years: [2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Motorhome U295": {
        years: [2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Motorhome U320": {
        years: [2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      }
    }
  },
  "freightliner": {
    label: "Freightliner", collection: "freightliner",
    models: {
      "Sprinter 2500": {
        years: [2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Sprinter 3500": {
        years: [2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "V Line": {
        years: [2002,1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "Xc": {
        years: [2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "Xc Formed Rail": {
        years: [2007,2006,2005],
        versions: ["Compatible"]
      },
      "Xc Lowered Rail": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "Xc Modular Rail": {
        years: [2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "Xc Raised Rail": {
        years: [2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "Xc Straight Rail": {
        years: [2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2003,2002,2001],
        versions: ["Compatible"]
      }
    }
  },
  "gmc": {
    label: "GMC", collection: "gmc",
    models: {
      "Acadia": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "C15": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "C15 C1500 Pickup": {
        years: [1973],
        versions: ["Compatible"]
      },
      "C15 C1500 Suburban": {
        years: [1973],
        versions: ["Compatible"]
      },
      "C15 Suburban": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "C1500": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "C1500 Suburban": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "C25": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "C25 C2500 Pickup": {
        years: [1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "C25 C2500 Suburban": {
        years: [1974,1973],
        versions: ["Compatible"]
      },
      "C25 Suburban": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "C2500": {
        years: [2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "C2500 Suburban": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "C35": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "C35 C3500 Pickup": {
        years: [1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "C3500": {
        years: [2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "C3500hd": {
        years: [1998,1997,1996,1995,1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "C4500 Topkick": {
        years: [2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "C5500 Topkick": {
        years: [2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "Caballero": {
        years: [1986,1985,1984,1983,1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      },
      "Canyon": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2012,2011,2010,2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "Envoy": {
        years: [2009,2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Envoy XL": {
        years: [2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "G15": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "G1500": {
        years: [1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "G25": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "G25 G2500 Van": {
        years: [1974,1973,1972],
        versions: ["Compatible"]
      },
      "G2500": {
        years: [1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "G35": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "G3500": {
        years: [1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "Jimmy": {
        years: [2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "K15": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "K15 K1500 Pickup": {
        years: [1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "K15 K1500 Suburban": {
        years: [1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "K15 Suburban": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "K1500": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "K1500 Suburban": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "K20": {
        years: [2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "K25": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "K25 K2500 Pickup": {
        years: [1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "K25 K2500 Suburban": {
        years: [1974,1973],
        versions: ["Compatible"]
      },
      "K25 Suburban": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "K2500": {
        years: [2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "K2500 Suburban": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "K30": {
        years: [2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "K35": {
        years: [1978,1977],
        versions: ["Compatible"]
      },
      "K35 K3500 Pickup": {
        years: [1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "K3500": {
        years: [2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "P15": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "P15 P1500 Van": {
        years: [1974,1973,1972,1971,1970,1969,1968,1967],
        versions: ["Compatible"]
      },
      "P1500": {
        years: [1980,1979],
        versions: ["Compatible"]
      },
      "P25": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "P25 P2500 Van": {
        years: [1974,1973],
        versions: ["Compatible"]
      },
      "P2500": {
        years: [1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "P35": {
        years: [1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "P35 P3500 Van": {
        years: [1974,1973],
        versions: ["Compatible"]
      },
      "P3500": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "PB1000 Series": {
        years: [1965,1964,1963],
        versions: ["Compatible"]
      },
      "PB15 Series": {
        years: [1966],
        versions: ["Compatible"]
      },
      "R1500": {
        years: [1987],
        versions: ["Compatible"]
      },
      "R1500 Suburban": {
        years: [1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "R2500": {
        years: [1989,1988,1987],
        versions: ["Compatible"]
      },
      "R2500 Suburban": {
        years: [1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "R3500": {
        years: [1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "S15": {
        years: [1990,1989,1988,1987,1986,1985,1984,1983,1982],
        versions: ["Compatible"]
      },
      "S15 Jimmy": {
        years: [1991,1990,1989,1988,1987,1986,1985,1984,1983],
        versions: ["Compatible"]
      },
      "Safari": {
        years: [2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985],
        versions: ["Compatible"]
      },
      "Savana 1500": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "Savana 2500": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "Savana 3500": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "Savana 4500": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Sierra 1500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "Sierra 1500 Classic": {
        years: [2007],
        versions: ["Compatible"]
      },
      "Sierra 1500 HD": {
        years: [2006,2005,2003,2002,2001],
        versions: ["Compatible"]
      },
      "Sierra 1500 HD Classic": {
        years: [2007],
        versions: ["Compatible"]
      },
      "Sierra 1500 Limited": {
        years: [2022,2019],
        versions: ["Compatible"]
      },
      "Sierra 2500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "Sierra 2500 HD": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "Sierra 2500 HD Classic": {
        years: [2007],
        versions: ["Compatible"]
      },
      "Sierra 3500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "Sierra 3500 Classic": {
        years: [2007],
        versions: ["Compatible"]
      },
      "Sierra 3500 HD": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "Sonoma": {
        years: [2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "Sprint": {
        years: [1977,1976,1975],
        versions: ["Compatible"]
      },
      "Syclone": {
        years: [1991],
        versions: ["Compatible"]
      },
      "Typhoon": {
        years: [1993,1992],
        versions: ["Compatible"]
      },
      "V1500": {
        years: [1987],
        versions: ["Compatible"]
      },
      "V1500 Suburban": {
        years: [1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "V2500": {
        years: [1987],
        versions: ["Compatible"]
      },
      "V2500 Suburban": {
        years: [1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "V3500": {
        years: [1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "Yukon": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992],
        versions: ["Compatible"]
      },
      "Yukon XL": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Yukon XL 1500": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Yukon XL 2500": {
        years: [2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      }
    }
  },
  "geo": {
    label: "Geo", collection: "geo",
    models: {
      "Tracker": {
        years: [1996,1995,1994,1993,1992,1991,1990,1989],
        versions: ["Compatible"]
      }
    }
  },
  "holiday": {
    label: "Holiday", collection: "holiday",
    models: {
      "Rambler Ambassador": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Rambler Endeavor": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "Rambler Endeavor Se": {
        years: [2005],
        versions: ["Compatible"]
      },
      "Rambler Imperial": {
        years: [2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Rambler Navigator": {
        years: [2010,2009,2008],
        versions: ["Compatible"]
      },
      "Rambler Neptune": {
        years: [2011,2010,2009,2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Rambler Scepter": {
        years: [2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "Rambler Vacationer": {
        years: [2016,2015,2014,2013,2012,2011,2009,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Rambler Vacationer XL": {
        years: [2008,2007,2006],
        versions: ["Compatible"]
      }
    }
  },
  "honda": {
    label: "Honda", collection: "honda",
    models: {
      "Accord": {
        years: [2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "CR-V": {
        years: [2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997],
        versions: ["LX AWD","EX AWD","EX-L AWD","Touring AWD"]
      },
      "CRF250R": {
        years: [2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "CRF450R": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Civic": {
        years: [2021,2020,2019,2018,2017,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "Civic Del Sol": {
        years: [1997,1996,1995,1994,1993],
        versions: ["Compatible"]
      },
      "Crx": {
        years: [1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "Fit": {
        years: [2020,2019,2018,2017,2016,2015,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Pilot": {
        years: [2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Ridgeline": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "S2000": {
        years: [2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Talon": {
        years: [2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      }
    }
  },
  "hummer": {
    label: "Hummer", collection: "hummer",
    models: {
      "H2": {
        years: [2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "H3": {
        years: [2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "H3 4wd": {
        years: [2006],
        versions: ["Compatible"]
      },
      "H3t": {
        years: [2010,2009],
        versions: ["Compatible"]
      }
    }
  },
  "hyundai": {
    label: "Hyundai", collection: "hyundai",
    models: {
      "Genesis Coupe": {
        years: [2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Ioniq": {
        years: [2022,2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "Sonata": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "Tucson": {
        years: [2021,2020,2019,2018,2017,2016],
        versions: ["Compatible"]
      }
    }
  },
  "infiniti": {
    label: "Infiniti", collection: "infiniti",
    models: {
      "G37": {
        years: [2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "QX30": {
        years: [2019,2018,2017],
        versions: ["Compatible"]
      },
      "QX56": {
        years: [2010,2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      }
    }
  },
  "international": {
    label: "International", collection: "international",
    models: {
      "Scout Ii": {
        years: [1980,1979,1978,1977,1976,1975,1974,1973,1972,1971],
        versions: ["Compatible"]
      }
    }
  },
  "isuzu": {
    label: "Isuzu", collection: "isuzu",
    models: {
      "Amigo": {
        years: [2000,1999,1998,1994,1993,1992,1991,1990,1989],
        versions: ["Compatible"]
      },
      "Ascender": {
        years: [2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "Hombre": {
        years: [2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "I 280": {
        years: [2006],
        versions: ["Compatible"]
      },
      "I 290": {
        years: [2008,2007],
        versions: ["Compatible"]
      },
      "I 350": {
        years: [2006],
        versions: ["Compatible"]
      },
      "I 370": {
        years: [2008,2007],
        versions: ["Compatible"]
      },
      "Rodeo": {
        years: [2002,2001,2000,1999,1998,1996,1995,1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "Rodeo Sport": {
        years: [2002,2001],
        versions: ["Compatible"]
      },
      "Trooper": {
        years: [2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984],
        versions: ["Compatible"]
      }
    }
  },
  "jaguar": {
    label: "Jaguar", collection: "jaguar",
    models: {
      "E Pace": {
        years: [2020,2019,2018],
        versions: ["Compatible"]
      },
      "F Pace": {
        years: [2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "F Type": {
        years: [2020,2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "S Type": {
        years: [2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Vanden Plas": {
        years: [2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990],
        versions: ["Compatible"]
      },
      "X Type": {
        years: [2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "XJ": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012,2011,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "XJ12": {
        years: [1996,1995,1994,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "XJ6": {
        years: [1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972],
        versions: ["Compatible"]
      },
      "XJ8": {
        years: [2003,2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "XJR575": {
        years: [2019,2018],
        versions: ["Compatible"]
      },
      "XK8": {
        years: [2006,2005,2004,2003,2002,2001,2000,1999,1998,1997],
        versions: ["Compatible"]
      },
      "Xf": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Xfr": {
        years: [2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Xjr": {
        years: [2017,2003,2002,2001,2000,1999,1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "Xjs": {
        years: [1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976],
        versions: ["Compatible"]
      },
      "Xk": {
        years: [2009,2008,2007],
        versions: ["Compatible"]
      },
      "Xkr": {
        years: [2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      }
    }
  },
  "jeep": {
    label: "Jeep", collection: "jeep",
    models: {
      "CJ5A": {
        years: [1968,1967,1966],
        versions: ["Compatible"]
      },
      "CJ8": {
        years: [1985,1984,1983,1982,1981],
        versions: ["Compatible"]
      },
      "Cherokee": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974],
        versions: ["Compatible"]
      },
      "Cherokee KL": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014],
        versions: ["Sport","Latitude","Altitude","Limited","Trailhawk"]
      },
      "Cherokee XJ": {
        years: [2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1959],
        versions: ["Sport","Country","Classic","Base"]
      },
      "Cj5": {
        years: [1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962,1961,1960,1959,1958,1957,1956,1955],
        versions: ["Compatible"]
      },
      "Cj5 4wd": {
        years: [1956,1955],
        versions: ["Compatible"]
      },
      "Cj6": {
        years: [1975,1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "Cj6 4wd": {
        years: [1956],
        versions: ["Compatible"]
      },
      "Cj7": {
        years: [1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962,1961,1960,1959,1958,1957,1956,1955],
        versions: ["Compatible"]
      },
      "Cj7 4wd 3 A 5 De Lift Trasero": {
        years: [1984],
        versions: ["Compatible"]
      },
      "Comanche": {
        years: [1992,1991,1990,1989,1988,1987,1986,1985,1984],
        versions: ["Compatible"]
      },
      "Commander": {
        years: [2010,2009,2008,2007,2006,2001,2000,1999],
        versions: ["Sport","Limited","Overland"]
      },
      "Compass": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "Gladiador": {
        years: [2026,2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Gladiador Mojave 206": {
        years: [2020],
        versions: ["Compatible"]
      },
      "Gladiator": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1967,1966],
        versions: ["Sport","Sport S","Overland","Rubicon","Mojave","Willys","Willys Sport","High Altitude","Compatible"]
      },
      "Gladiator JT": {
        years: [2026,2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Grand Cherokee": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986],
        versions: ["Compatible"]
      },
      "Grand Cherokee L": {
        years: [2026,2025,2024,2023,2022,2021],
        versions: ["Compatible"]
      },
      "Grand Cherokee WJ": {
        years: [2004,2003,2002,2001,2000,1999,1986,1985,1984],
        versions: ["Laredo","Limited","Sport","Overland","Columbia","Freedom"]
      },
      "Grand Cherokee WK": {
        years: [2010,2009,2008,2007,2006,2005,2000,1999],
        versions: ["Laredo","Limited","Overland","SRT8"]
      },
      "Grand Cherokee WK2": {
        years: [2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011],
        versions: ["Laredo","Altitude","Limited","Overland","Summit","Trailhawk","SRT","Trackhawk"]
      },
      "Grand Cherokee WL": {
        years: [2026,2025,2024,2023],
        versions: ["Laredo","Altitude","Limited","Overland","Summit","Trailhawk"]
      },
      "Grand Cherokee ZJ": {
        years: [1998,1997,1996,1995,1994,1993],
        versions: ["Laredo","Limited","Orvis"]
      },
      "Grand Wagoneer": {
        years: [1993,1991,1990,1989,1988,1987,1986,1985,1984],
        versions: ["Compatible"]
      },
      "J10": {
        years: [1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974],
        versions: ["Compatible"]
      },
      "J20": {
        years: [1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974],
        versions: ["Compatible"]
      },
      "Liberty": {
        years: [2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Liberty Kj": {
        years: [2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "M38a1 4wd": {
        years: [1955],
        versions: ["Compatible"]
      },
      "Patriot": {
        years: [2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "Renegade": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Scrambler": {
        years: [1985,1984,1983,1982,1981,1976],
        versions: ["Compatible"]
      },
      "TJ": {
        years: [2006,2005,2004,2003,2002,2001,2000,1999,1998,1997],
        versions: ["Compatible"]
      },
      "Wagoneer": {
        years: [2025,2024,2023,2022,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "Wrangler": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984],
        versions: ["Compatible"]
      },
      "Wrangler JK": {
        years: [2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,1986,1985,1984],
        versions: ["Sport 2 Puertas","Sport S 2 Puertas","Sahara 2 Puertas","Rubicon 2 Puertas","Sport Unlimited 4 Puertas","Sport S Unlimited 4 Puertas","Sahara Unlimited 4 Puertas","Rubicon Unlimited 4 Puertas"]
      },
      "Wrangler JL": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2009,2008,2007],
        versions: ["Sport 2 Puertas","Sport S 2 Puertas","Sahara 2 Puertas","Rubicon 2 Puertas","Willys 2 Puertas","Sport Unlimited 4 Puertas","Sport S Unlimited 4 Puertas","Sahara Unlimited 4 Puertas","Rubicon Unlimited 4 Puertas","Willys Unlimited 4 Puertas","High Altitude Unlimited 4 Puertas","Rubicon 392 Unlimited 4 Puertas","Rubicon 4xe Unlimited 4 Puertas","Sahara 4xe Unlimited 4 Puertas","Freedom Unlimited 4 Puertas"]
      },
      "Wrangler LJ": {
        years: [2006,2005,2004],
        versions: ["Compatible"]
      },
      "Wrangler TJ": {
        years: [2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1986,1985,1984],
        versions: ["Sport","Sahara","Rubicon","SE","Unlimited","Compatible"]
      },
      "Wrangler Unlimited": {
        years: [2006,2005,2004],
        versions: ["Compatible"]
      },
      "Wrangler YJ": {
        years: [1995,1994,1993,1992,1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      }
    }
  },
  "john-deere": {
    label: "John Deere", collection: "john-deere",
    models: {
      "Gator": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      }
    }
  },
  "kawasaki": {
    label: "Kawasaki", collection: "kawasaki",
    models: {
      "KX250F": {
        years: [2018,2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "KX450F": {
        years: [2018,2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Teryx": {
        years: [2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      }
    }
  },
  "kia": {
    label: "Kia", collection: "kia",
    models: {
      "Forte": {
        years: [2012,2011,2010],
        versions: ["Compatible"]
      },
      "Sorento": {
        years: [2020,2019,2018,2017,2016,2013,2012,2011,2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "Soul": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Sportage": {
        years: [2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "Telluride": {
        years: [2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      }
    }
  },
  "land-rover": {
    label: "Land Rover", collection: "land-rover",
    models: {
      "Defender 110": {
        years: [1993],
        versions: ["Compatible"]
      },
      "Defender 90": {
        years: [1997,1995,1994],
        versions: ["Compatible"]
      },
      "Discovery": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "Discovery Sport": {
        years: [2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "LR2": {
        years: [2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "Lr3": {
        years: [2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "Lr4": {
        years: [2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Range Rover": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "Range Rover Evoque": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012],
        versions: ["Compatible"]
      },
      "Range Rover Sport": {
        years: [2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      }
    }
  },
  "lexus": {
    label: "Lexus", collection: "lexus",
    models: {
      "GS300": {
        years: [2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993],
        versions: ["Compatible"]
      },
      "GS400": {
        years: [2000,1999,1998],
        versions: ["Compatible"]
      },
      "GS430": {
        years: [2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "GX460": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Gx470": {
        years: [2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "Gx550": {
        years: [2025,2024],
        versions: ["Compatible"]
      },
      "IS300": {
        years: [2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "Is F": {
        years: [2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "LS400": {
        years: [2000,1999,1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "Lx450": {
        years: [1997,1996],
        versions: ["Compatible"]
      },
      "Lx470": {
        years: [2007,2006,2005,2004,2003,2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "NX200T": {
        years: [2017,2016,2015],
        versions: ["Compatible"]
      },
      "NX300": {
        years: [2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "NX300H": {
        years: [2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      }
    }
  },
  "lincoln": {
    label: "Lincoln", collection: "lincoln",
    models: {
      "Blackwood": {
        years: [2002],
        versions: ["Compatible"]
      },
      "Continental": {
        years: [1983,1982,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "Mark Iv": {
        years: [1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "Mark Lt": {
        years: [2008,2007,2006],
        versions: ["Compatible"]
      },
      "Mark V": {
        years: [1979,1978,1977],
        versions: ["Compatible"]
      },
      "Mkx": {
        years: [2018,2017,2016],
        versions: ["Compatible"]
      },
      "Mkz": {
        years: [2009,2008,2007],
        versions: ["Compatible"]
      },
      "Nautilus": {
        years: [2019],
        versions: ["Compatible"]
      },
      "Navigator": {
        years: [2019,2018,2017,2015,2014,2013,2012,2011,2010,2009,2008,2007,2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "Town Car": {
        years: [2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982],
        versions: ["Compatible"]
      },
      "Zephyr": {
        years: [2006],
        versions: ["Compatible"]
      }
    }
  },
  "mini": {
    label: "MINI", collection: "mini",
    models: {
      "Cooper": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Cooper Clubman": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "Cooper Countryman": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011],
        versions: ["Compatible"]
      },
      "Cooper Paceman": {
        years: [2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "Countryman": {
        years: [2025],
        versions: ["Compatible"]
      }
    }
  },
  "mazda": {
    label: "Mazda", collection: "mazda",
    models: {
      "2": {
        years: [2014,2013,2012,2011],
        versions: ["Compatible"]
      },
      "3": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "5": {
        years: [2015,2014,2013,2012,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "6": {
        years: [2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "B2200": {
        years: [1993,1992,1991,1990],
        versions: ["Compatible"]
      },
      "B2300": {
        years: [2009,2008,2007,2006,2005,2004,2003,2002,2001,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "B2500": {
        years: [2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "B2600": {
        years: [1993,1992,1991,1990],
        versions: ["Compatible"]
      },
      "B3000": {
        years: [2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1996,1995,1994],
        versions: ["Compatible"]
      },
      "B4000": {
        years: [2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "Cx 3": {
        years: [2021,2020,2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "Cx 5": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "Cx 7": {
        years: [2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "MX-5 Miata": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "Miata": {
        years: [2005,2004,2003,2002,2001,2000,1999,1997,1996,1995,1994,1993,1992,1991,1990],
        versions: ["Compatible"]
      },
      "Navajo": {
        years: [1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "Rx 7": {
        years: [1991,1990,1989,1988,1987,1986],
        versions: ["Compatible"]
      },
      "Rx 8": {
        years: [2011,2010,2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "Tribute": {
        years: [2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      }
    }
  },
  "mercedes": {
    label: "Mercedes", collection: "mercedes",
    models: {
      "Benz": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      }
    }
  },
  "mercedes-benz": {
    label: "Mercedes-Benz", collection: "mercedes-benz",
    models: {
      "180d": {
        years: [1961,1960],
        versions: ["Compatible"]
      },
      "190c": {
        years: [1965,1964,1963],
        versions: ["Compatible"]
      },
      "190d": {
        years: [1989,1988,1987,1986,1985,1984],
        versions: ["Compatible"]
      },
      "190dc": {
        years: [1965,1964,1963],
        versions: ["Compatible"]
      },
      "190e": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984],
        versions: ["Compatible"]
      },
      "200": {
        years: [1968,1967,1966],
        versions: ["Compatible"]
      },
      "200d": {
        years: [1968,1967,1966],
        versions: ["Compatible"]
      },
      "220": {
        years: [1973,1972,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "220d": {
        years: [1973,1972,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "220s": {
        years: [1959,1958,1957,1956],
        versions: ["Compatible"]
      },
      "230": {
        years: [1978,1977,1976,1975,1974,1969,1968,1967,1966],
        versions: ["Compatible"]
      },
      "230s": {
        years: [1967,1966],
        versions: ["Compatible"]
      },
      "230sl": {
        years: [1967,1966,1965,1964,1963],
        versions: ["Compatible"]
      },
      "240d": {
        years: [1983,1982,1981,1980,1979,1978,1977,1976,1975,1974],
        versions: ["Compatible"]
      },
      "250": {
        years: [1970,1969,1968],
        versions: ["Compatible"]
      },
      "250c": {
        years: [1972,1971,1970],
        versions: ["Compatible"]
      },
      "250s": {
        years: [1967,1966],
        versions: ["Compatible"]
      },
      "250se": {
        years: [1967,1966],
        versions: ["Compatible"]
      },
      "250sl": {
        years: [1967],
        versions: ["Compatible"]
      },
      "260e": {
        years: [1989,1988,1987],
        versions: ["Compatible"]
      },
      "280": {
        years: [1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "280c": {
        years: [1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "280ce": {
        years: [1981,1980,1979,1978],
        versions: ["Compatible"]
      },
      "280e": {
        years: [1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "280s": {
        years: [1976,1975,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "280se": {
        years: [1980,1979,1978,1977,1973,1972,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "280sel": {
        years: [1973,1972,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "280sl": {
        years: [1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "300cd": {
        years: [1985,1984,1983,1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      },
      "300ce": {
        years: [1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "300d": {
        years: [1993,1992,1991,1990,1987,1985,1984,1983,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "300e": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986],
        versions: ["Compatible"]
      },
      "300sd": {
        years: [1993,1992,1985,1984,1983,1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      },
      "300sdl": {
        years: [1987,1986],
        versions: ["Compatible"]
      },
      "300se": {
        years: [1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "300sel": {
        years: [1991,1990,1989,1988,1972,1971,1970,1969,1968,1967,1966,1965],
        versions: ["Compatible"]
      },
      "300sl": {
        years: [1993,1992,1991,1990],
        versions: ["Compatible"]
      },
      "300td": {
        years: [1987,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "300te": {
        years: [1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "350sd": {
        years: [1991],
        versions: ["Compatible"]
      },
      "350sdl": {
        years: [1991,1990],
        versions: ["Compatible"]
      },
      "350sl": {
        years: [1972],
        versions: ["Compatible"]
      },
      "380se": {
        years: [1985,1984],
        versions: ["Compatible"]
      },
      "380sec": {
        years: [1983,1982],
        versions: ["Compatible"]
      },
      "380sel": {
        years: [1983,1982,1981],
        versions: ["Compatible"]
      },
      "380sl": {
        years: [1985,1984,1983,1982,1981],
        versions: ["Compatible"]
      },
      "380slc": {
        years: [1981],
        versions: ["Compatible"]
      },
      "400e": {
        years: [1993,1992],
        versions: ["Compatible"]
      },
      "400se": {
        years: [1992],
        versions: ["Compatible"]
      },
      "400sel": {
        years: [1993],
        versions: ["Compatible"]
      },
      "420sel": {
        years: [1991,1990,1989,1988,1987,1986],
        versions: ["Compatible"]
      },
      "450se": {
        years: [1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "450sel": {
        years: [1980,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "450sl": {
        years: [1980,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "450slc": {
        years: [1980,1979,1978,1977,1976,1975,1974,1973],
        versions: ["Compatible"]
      },
      "500sec": {
        years: [1993,1985,1984],
        versions: ["Compatible"]
      },
      "500sel": {
        years: [1993,1992,1985,1984],
        versions: ["Compatible"]
      },
      "500sl": {
        years: [1993,1992,1991,1990],
        versions: ["Compatible"]
      },
      "560sec": {
        years: [1991,1990,1989,1988,1987,1986],
        versions: ["Compatible"]
      },
      "560sel": {
        years: [1991,1990,1989,1988,1987,1986],
        versions: ["Compatible"]
      },
      "560sl": {
        years: [1989,1988,1987,1986],
        versions: ["Compatible"]
      },
      "600sel": {
        years: [1993,1992],
        versions: ["Compatible"]
      },
      "600sl": {
        years: [1993],
        versions: ["Compatible"]
      },
      "A220": {
        years: [2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "A35 Amg": {
        years: [2021,2020],
        versions: ["Compatible"]
      },
      "Amg Gt 43": {
        years: [2023,2022,2021],
        versions: ["Compatible"]
      },
      "Amg Gt 53": {
        years: [2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "Amg Gt 63": {
        years: [2023,2021,2020,2019],
        versions: ["Compatible"]
      },
      "Amg Gt 63 S": {
        years: [2023,2021,2020,2019],
        versions: ["Compatible"]
      },
      "B Electric Drive": {
        years: [2015,2014],
        versions: ["Compatible"]
      },
      "B200": {
        years: [2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "B250E": {
        years: [2017,2016],
        versions: ["Compatible"]
      },
      "C220": {
        years: [1996,1995,1994],
        versions: ["Compatible"]
      },
      "C230": {
        years: [2007,2006,2005,2004,2003,2002,2000,1999,1998,1997],
        versions: ["Compatible"]
      },
      "C240": {
        years: [2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "C250": {
        years: [2015,2014,2013,2012],
        versions: ["Compatible"]
      },
      "C280": {
        years: [2007,2006,2000,1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "C300": {
        years: [2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "C32 Amg": {
        years: [2004,2003,2002],
        versions: ["Compatible"]
      },
      "C320": {
        years: [2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "C350": {
        years: [2015,2014,2013,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "C350E": {
        years: [2018,2017,2016],
        versions: ["Compatible"]
      },
      "C400": {
        years: [2015],
        versions: ["Compatible"]
      },
      "C43 Amg": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "C450 Amg": {
        years: [2016],
        versions: ["Compatible"]
      },
      "C55 Amg": {
        years: [2006,2005],
        versions: ["Compatible"]
      },
      "C63 Amg": {
        years: [2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "C63 Amg S": {
        years: [2023,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "CL500": {
        years: [1999,1998],
        versions: ["Compatible"]
      },
      "CL550": {
        years: [2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "CL600": {
        years: [2014,2013,2012,1999,1998],
        versions: ["Compatible"]
      },
      "CLA250": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "CLA35 Amg": {
        years: [2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "CLA45 Amg": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "CLA45 Amg S": {
        years: [2025,2024],
        versions: ["Compatible"]
      },
      "CLK320": {
        years: [2005,2004,2003,2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "CLK350": {
        years: [2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "CLK430": {
        years: [2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "CLK500": {
        years: [2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "CLK55 Amg": {
        years: [2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "CLK550": {
        years: [2009,2008,2007],
        versions: ["Compatible"]
      },
      "CLK63 Amg": {
        years: [2008,2007],
        versions: ["Compatible"]
      },
      "CLS400": {
        years: [2017,2016,2015],
        versions: ["Compatible"]
      },
      "CLS450": {
        years: [2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "CLS500": {
        years: [2006],
        versions: ["Compatible"]
      },
      "CLS55 Amg": {
        years: [2006],
        versions: ["Compatible"]
      },
      "CLS550": {
        years: [2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "CLS63 Amg": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "CLS63 Amg S": {
        years: [2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "E250": {
        years: [2016,2015,2014],
        versions: ["Compatible"]
      },
      "E300": {
        years: [2019,2018,2017,1999,1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "E320": {
        years: [2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "E350": {
        years: [2025,2024,2023,2022,2021,2020,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "E400": {
        years: [2018,2017,2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "E420": {
        years: [1997,1995,1994],
        versions: ["Compatible"]
      },
      "E43 Amg": {
        years: [2018,2017],
        versions: ["Compatible"]
      },
      "E430": {
        years: [2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "E450": {
        years: [2025,2024,2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "E500": {
        years: [2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "E53 Amg": {
        years: [2021,2020,2019],
        versions: ["Compatible"]
      },
      "E55 Amg": {
        years: [2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "E550": {
        years: [2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "E63 Amg": {
        years: [2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "E63 Amg S": {
        years: [2018,2016,2015,2014],
        versions: ["Compatible"]
      },
      "Eqb 250": {
        years: [2025,2024,2023],
        versions: ["Compatible"]
      },
      "Eqb 300": {
        years: [2025,2024,2023,2022],
        versions: ["Compatible"]
      },
      "Eqb 350": {
        years: [2025,2024,2023,2022],
        versions: ["Compatible"]
      },
      "G500": {
        years: [2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "G55 Amg": {
        years: [2011,2010,2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "G550": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "G63 4x4 Squared Amg": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "G63 Amg": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "G65 Amg": {
        years: [2018,2017,2016],
        versions: ["Compatible"]
      },
      "GL320": {
        years: [2009,2008,2007],
        versions: ["Compatible"]
      },
      "GL350": {
        years: [2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "GL450": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "GL550": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "GL63 Amg": {
        years: [2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "GLA250": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "GLA45 Amg": {
        years: [2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "GLB250": {
        years: [2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "GLC300": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "GLC350E": {
        years: [2020,2019,2018],
        versions: ["Compatible"]
      },
      "GLC43 Amg": {
        years: [2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "GLC63 Amg": {
        years: [2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "GLC63 Amg S": {
        years: [2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "GLE300D": {
        years: [2017,2016],
        versions: ["Compatible"]
      },
      "GLE350": {
        years: [2025,2024,2023,2022,2021,2020,2018,2017,2016],
        versions: ["Compatible"]
      },
      "GLE400": {
        years: [2019,2017,2016],
        versions: ["Compatible"]
      },
      "GLE43 Amg": {
        years: [2019,2018,2017],
        versions: ["Compatible"]
      },
      "GLE450": {
        years: [2026,2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "GLE450 Suv": {
        years: [2026,2025,2024,2023,2022],
        versions: ["Compatible"]
      },
      "GLE450E": {
        years: [2026,2025,2024],
        versions: ["Compatible"]
      },
      "GLE550": {
        years: [2018],
        versions: ["Compatible"]
      },
      "GLE550E": {
        years: [2018,2017,2016],
        versions: ["Compatible"]
      },
      "GLE580": {
        years: [2026,2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "GLE63 Amg": {
        years: [2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "GLE63 Amg S": {
        years: [2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "GLK250": {
        years: [2015,2014,2013],
        versions: ["Compatible"]
      },
      "GLK350": {
        years: [2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "GLS350D": {
        years: [2017],
        versions: ["Compatible"]
      },
      "GLS450": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "GLS550": {
        years: [2019,2018,2017],
        versions: ["Compatible"]
      },
      "GLS580": {
        years: [2026,2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "ML250": {
        years: [2015],
        versions: ["Compatible"]
      },
      "ML320": {
        years: [2009,2008,2007,2003,2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "ML350": {
        years: [2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "ML400": {
        years: [2015],
        versions: ["Compatible"]
      },
      "ML430": {
        years: [2001,2000,1999],
        versions: ["Compatible"]
      },
      "ML450": {
        years: [2011,2010],
        versions: ["Compatible"]
      },
      "ML500": {
        years: [2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "ML55 Amg": {
        years: [2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "ML550": {
        years: [2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "ML63 Amg": {
        years: [2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "Maybach S680": {
        years: [2025,2024,2023,2022],
        versions: ["Compatible"]
      },
      "Metris": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "R320": {
        years: [2009,2008,2007],
        versions: ["Compatible"]
      },
      "R350": {
        years: [2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "R500": {
        years: [2007,2006],
        versions: ["Compatible"]
      },
      "R63 Amg": {
        years: [2007],
        versions: ["Compatible"]
      },
      "S320": {
        years: [1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "S350": {
        years: [2013,2012,1995,1994],
        versions: ["Compatible"]
      },
      "S400": {
        years: [2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "S420": {
        years: [1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "S450": {
        years: [2020,2019,2018],
        versions: ["Compatible"]
      },
      "S500": {
        years: [2025,2024,2023,2022,2021,1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "S550": {
        years: [2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "S550E": {
        years: [2017,2016,2015],
        versions: ["Compatible"]
      },
      "S560E": {
        years: [2020,2019],
        versions: ["Compatible"]
      },
      "S580": {
        years: [2025,2024,2023,2022,2021],
        versions: ["Compatible"]
      },
      "S580E": {
        years: [2025,2024,2023],
        versions: ["Compatible"]
      },
      "S600": {
        years: [1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "SL320": {
        years: [1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "SL400": {
        years: [2016,2015],
        versions: ["Compatible"]
      },
      "SL450": {
        years: [2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "SL500": {
        years: [2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "SL55 Amg": {
        years: [2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "SL550": {
        years: [2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2009,2008,2007],
        versions: ["Compatible"]
      },
      "SL600": {
        years: [2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "SL63 Amg": {
        years: [2019,2018,2013,2012,2011,2009],
        versions: ["Compatible"]
      },
      "SL65 Amg": {
        years: [2011,2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "SLC300": {
        years: [2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "SLC43 Amg": {
        years: [2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "SLK230": {
        years: [2004,2003,2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "SLK250": {
        years: [2015,2014,2013,2012],
        versions: ["Compatible"]
      },
      "SLK280": {
        years: [2008,2007,2006],
        versions: ["Compatible"]
      },
      "SLK300": {
        years: [2016,2011,2010,2009],
        versions: ["Compatible"]
      },
      "SLK32 Amg": {
        years: [2004,2003,2002],
        versions: ["Compatible"]
      },
      "SLK320": {
        years: [2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "SLK350": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "SLK55 Amg": {
        years: [2016,2015,2014,2013,2012,2010,2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "Sprinter": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "Sprinter 1500": {
        years: [2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "Sprinter 2500": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Sprinter 3500": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Sprinter 3500xd": {
        years: [2024,2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      }
    }
  },
  "mercury": {
    label: "Mercury", collection: "mercury",
    models: {
      "Colony Park": {
        years: [1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "Comet": {
        years: [1977,1976,1975],
        versions: ["Compatible"]
      },
      "Cougar": {
        years: [1982,1981,1979,1978,1977,1976,1975,1974],
        versions: ["Compatible"]
      },
      "Grand Marquis": {
        years: [2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Marquis": {
        years: [1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Milan": {
        years: [2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "Monarch": {
        years: [1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Montego": {
        years: [1976,1975],
        versions: ["Compatible"]
      },
      "Mountaineer": {
        years: [2001,2000,1999,1998,1997],
        versions: ["Compatible"]
      },
      "Zephyr": {
        years: [1983,1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      }
    }
  },
  "merkur": {
    label: "Merkur", collection: "merkur",
    models: {
      "XR4TI": {
        years: [1989,1988,1987,1986,1985],
        versions: ["Compatible"]
      }
    }
  },
  "mitsubishi": {
    label: "Mitsubishi", collection: "mitsubishi",
    models: {
      "3000gt": {
        years: [1999,1998,1997,1996,1995,1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "Lancer": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009,2008,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "Montero": {
        years: [2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983],
        versions: ["Compatible"]
      },
      "Montero Sport": {
        years: [2004,2003,2002,2001,2000,1999,1998,1997],
        versions: ["Compatible"]
      },
      "Outlander": {
        years: [2026,2025,2024,2023,2022,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      }
    }
  },
  "monaco": {
    label: "Monaco", collection: "monaco",
    models: {
      "Coach Camelot": {
        years: [2011,2010,2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "Coach Cayman": {
        years: [2011,2009,2008,2007,2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      },
      "Coach Diplomat": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Coach Diplomat Le": {
        years: [2002,2001],
        versions: ["Compatible"]
      },
      "Coach Dynasty": {
        years: [2011,2010,2009,2008,2007,2006,2005,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Coach Executive": {
        years: [2009,2008,2007,2006,2005,2004,2003,2001,2000],
        versions: ["Compatible"]
      },
      "Coach Knight": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2002],
        versions: ["Compatible"]
      },
      "Coach La Palma": {
        years: [2013,2012,2009,2006,2005,2004,2003,2002,2000],
        versions: ["Compatible"]
      },
      "Coach La Palma Diesel": {
        years: [2006],
        versions: ["Compatible"]
      },
      "Coach La Palma XL": {
        years: [2008,2007],
        versions: ["Compatible"]
      },
      "Coach Monarch": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2002,2001],
        versions: ["Compatible"]
      },
      "Coach Monarch Se": {
        years: [2005,2004,2003],
        versions: ["Compatible"]
      },
      "Coach Monarch Sve": {
        years: [2007],
        versions: ["Compatible"]
      },
      "Coach Signature Series": {
        years: [2010,2009,2008,2007,2006,2005,2002,2000],
        versions: ["Compatible"]
      },
      "Coach Windsor": {
        years: [2006,2005,2004,2002,2001,2000],
        versions: ["Compatible"]
      }
    }
  },
  "nissan": {
    label: "Nissan", collection: "nissan",
    models: {
      "240sx": {
        years: [1998,1997,1996,1995,1994,1993,1992,1991,1990,1989],
        versions: ["Compatible"]
      },
      "350z": {
        years: [2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "370z": {
        years: [2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Armada": {
        years: [2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "D21": {
        years: [1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986],
        versions: ["STD Regular Cab","XE Regular Cab","XE King Cab","SE King Cab","4WD Regular Cab","4WD King Cab"]
      },
      "Frontier": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998],
        versions: ["S King Cab","SV King Cab","SV Crew Cab","PRO-4X King Cab","PRO-4X Crew Cab","SL Crew Cab","Desert Runner"]
      },
      "Juke": {
        years: [2017,2016,2015,2014,2013,2012,2011],
        versions: ["Compatible"]
      },
      "Pathfinder": {
        years: [2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986],
        versions: ["Compatible"]
      },
      "Pathfinder Armada": {
        years: [2004],
        versions: ["Compatible"]
      },
      "Pickup": {
        years: [1997,1996,1995],
        versions: ["Compatible"]
      },
      "Rogue": {
        years: [2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "Rogue Select": {
        years: [2015,2014],
        versions: ["Compatible"]
      },
      "Rogue Sport": {
        years: [2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "Titan": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2000],
        versions: ["Compatible"]
      },
      "Titan Xd": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "Xterra": {
        years: [2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["S","X","PRO-4X"]
      },
      "Z": {
        years: [2026,2025,2024,2023],
        versions: ["Compatible"]
      }
    }
  },
  "oldsmobile": {
    label: "Oldsmobile", collection: "oldsmobile",
    models: {
      "98": {
        years: [1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "Bravada": {
        years: [2004,2003,2002,2001,2000,1999,1998,1997,1996,1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "Custom Cruiser": {
        years: [1977,1976,1975],
        versions: ["Compatible"]
      },
      "Cutlass": {
        years: [1997,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964],
        versions: ["Compatible"]
      },
      "Cutlass Calais": {
        years: [1984,1983,1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      },
      "Cutlass Cruiser": {
        years: [1983,1982,1981,1980],
        versions: ["Compatible"]
      },
      "Cutlass Salon": {
        years: [1987,1986,1985,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Cutlass Supreme": {
        years: [1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "Cutlass Tiara": {
        years: [1976],
        versions: ["Compatible"]
      },
      "Delta 88": {
        years: [1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "F85": {
        years: [1972,1971,1970,1969,1968,1967,1966,1965,1964],
        versions: ["Compatible"]
      },
      "Toronado": {
        years: [1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      }
    }
  },
  "oshkosh": {
    label: "Oshkosh", collection: "oshkosh",
    models: {
      "Motor Truck Co V Line": {
        years: [1995,1994,1993,1992,1991,1990],
        versions: ["Compatible"]
      }
    }
  },
  "plymouth": {
    label: "Plymouth", collection: "plymouth",
    models: {
      "Grand Voyager": {
        years: [2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "PB300": {
        years: [1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "PB350": {
        years: [1983,1982,1981],
        versions: ["Compatible"]
      },
      "Trailduster": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "Voyager": {
        years: [2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984],
        versions: ["Compatible"]
      }
    }
  },
  "polaris": {
    label: "Polaris", collection: "polaris",
    models: {
      "Dagor": {
        years: [2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Rzr": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "Rzr Pro R 4 Premium": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "Rzr Pro R 4 Sport": {
        years: [2022],
        versions: ["Compatible"]
      },
      "Rzr Pro R 4 Ultimate": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "Rzr Pro R 4 Ultimate Launch Edition": {
        years: [2022],
        versions: ["Compatible"]
      },
      "Rzr Pro R Premium": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "Rzr Pro R Sport": {
        years: [2022],
        versions: ["Compatible"]
      },
      "Rzr Pro R Ultimate": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "Rzr Pro R Ultimate Launch Edition": {
        years: [2022],
        versions: ["Compatible"]
      },
      "Rzr Pro S 4 Premium": {
        years: [2025],
        versions: ["Compatible"]
      },
      "Rzr Pro S 4 Sport": {
        years: [2025],
        versions: ["Compatible"]
      },
      "Rzr Pro S 4 Ultimate": {
        years: [2025],
        versions: ["Compatible"]
      },
      "Rzr Turbo R 4 Premium": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "Rzr Turbo R 4 Sport": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "Rzr Turbo R 4 Ultimate": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "Rzr Turbo S": {
        years: [2022,2021],
        versions: ["Compatible"]
      },
      "Rzr Turbo S Lifted Lime Le": {
        years: [2021],
        versions: ["Compatible"]
      },
      "Rzr Turbo S Velocity": {
        years: [2022,2021],
        versions: ["Compatible"]
      },
      "Rzr Turbo S4": {
        years: [2022,2021],
        versions: ["Compatible"]
      },
      "Rzr Turbo S4 Lifted Lime Le": {
        years: [2021],
        versions: ["Compatible"]
      },
      "Rzr Turbo S4 Velocity": {
        years: [2022,2021],
        versions: ["Compatible"]
      },
      "Rzr Xp 1000": {
        years: [2021,2020],
        versions: ["Compatible"]
      },
      "Rzr Xp 1000 Eps": {
        years: [2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "Rzr Xp 1000 Eps Dynamix Edition": {
        years: [2019],
        versions: ["Compatible"]
      },
      "Rzr Xp 1000 Eps High Lifter Edition": {
        years: [2019,2018,2017],
        versions: ["Compatible"]
      },
      "Rzr Xp 1000 Eps Ride Command Edition": {
        years: [2019,2018],
        versions: ["Compatible"]
      },
      "Rzr Xp 1000 High Lifter": {
        years: [2022],
        versions: ["Compatible"]
      },
      "Rzr Xp 1000 High Lifter Edition": {
        years: [2021,2020],
        versions: ["Compatible"]
      },
      "Rzr Xp 1000 Limited Edition": {
        years: [2020],
        versions: ["Compatible"]
      },
      "Rzr Xp 1000 Premium": {
        years: [2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Rzr Xp 1000 Sport": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "Rzr Xp 1000 Ultimate": {
        years: [2024,2023],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 1000": {
        years: [2021,2020],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 1000 Eps": {
        years: [2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 1000 Eps Dynamix Edition": {
        years: [2019],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 1000 Eps High Lifter Edition": {
        years: [2019,2018,2017],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 1000 Eps Ride Command Edition": {
        years: [2019,2018],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 1000 High Lifter": {
        years: [2022],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 1000 High Lifter Edition": {
        years: [2021,2020],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 1000 Limited Edition": {
        years: [2020],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 1000 Premium": {
        years: [2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 1000 Sport": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 1000 Ultimate": {
        years: [2024,2023],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 Turbo": {
        years: [2021,2020,2019],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 Turbo Eps": {
        years: [2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 Turbo Eps Dynamix Edition": {
        years: [2019,2018],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 Turbo Eps Fox Edition": {
        years: [2018],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 Turbo Eps Le": {
        years: [2019],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 Turbo S": {
        years: [2021,2020,2019],
        versions: ["Compatible"]
      },
      "Rzr Xp 4 Turbo S Velocity": {
        years: [2021,2020],
        versions: ["Compatible"]
      },
      "Rzr Xp Turbo": {
        years: [2021,2020],
        versions: ["Compatible"]
      },
      "Rzr Xp Turbo Eps": {
        years: [2019,2018,2017,2016],
        versions: ["Compatible"]
      },
      "Rzr Xp Turbo Eps Dynamix Edition": {
        years: [2019,2018],
        versions: ["Compatible"]
      },
      "Rzr Xp Turbo Eps Fox Edition": {
        years: [2018],
        versions: ["Compatible"]
      },
      "Rzr Xp Turbo Eps Le": {
        years: [2019],
        versions: ["Compatible"]
      },
      "Rzr Xp Turbo S": {
        years: [2020,2019,2018],
        versions: ["Compatible"]
      },
      "Rzr Xp Turbo S Velocity": {
        years: [2020],
        versions: ["Compatible"]
      }
    }
  },
  "pontiac": {
    label: "Pontiac", collection: "pontiac",
    models: {
      "Bonneville": {
        years: [1986,1985,1984,1983,1982],
        versions: ["Compatible"]
      },
      "Firebird": {
        years: [2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967],
        versions: ["Compatible"]
      },
      "G5": {
        years: [2009,2008,2007],
        versions: ["Compatible"]
      },
      "Grand Am": {
        years: [1980,1979,1978,1975],
        versions: ["Compatible"]
      },
      "Grand Prix": {
        years: [1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Gto": {
        years: [1972,1971,1970,1969,1968,1967,1966,1965,1964],
        versions: ["Compatible"]
      },
      "Lemans": {
        years: [1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964],
        versions: ["Compatible"]
      },
      "Parisienne": {
        years: [1986,1985,1984,1983],
        versions: ["Compatible"]
      },
      "Tempest": {
        years: [1967,1966,1965,1964],
        versions: ["Compatible"]
      }
    }
  },
  "porsche": {
    label: "Porsche", collection: "porsche",
    models: {
      "356": {
        years: [1955,1954,1953,1952,1951,1950,1949,1948],
        versions: ["Compatible"]
      },
      "356a": {
        years: [1959,1958,1957,1956,1955],
        versions: ["Compatible"]
      },
      "356b": {
        years: [1963,1962,1961,1960],
        versions: ["Compatible"]
      },
      "356c": {
        years: [1965,1964],
        versions: ["Compatible"]
      },
      "356sc": {
        years: [1965,1964],
        versions: ["Compatible"]
      },
      "718 Boxster": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "718 Cayman": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "911": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965],
        versions: ["Compatible"]
      },
      "912": {
        years: [1976,1969,1968,1967,1966,1965],
        versions: ["Compatible"]
      },
      "914": {
        years: [1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "924": {
        years: [1988,1987,1982,1981,1980,1979,1978,1977],
        versions: ["Compatible"]
      },
      "928": {
        years: [1995,1994,1993,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978],
        versions: ["Compatible"]
      },
      "930": {
        years: [1979,1978],
        versions: ["Compatible"]
      },
      "944": {
        years: [1991,1990,1989,1988,1987,1986,1985,1984,1983],
        versions: ["Compatible"]
      },
      "968": {
        years: [1995,1994,1993,1992],
        versions: ["Compatible"]
      },
      "Boxster": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997],
        versions: ["Compatible"]
      },
      "Cayenne": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2006,2005,2004,2003],
        versions: ["Compatible"]
      },
      "Cayman": {
        years: [2016,2015,2014,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "Macan": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Panamera": {
        years: [2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      }
    }
  },
  "ram": {
    label: "RAM", collection: "ram",
    models: {
      "1500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994],
        versions: ["Compatible"]
      },
      "1500 Classic": {
        years: [2024,2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "2500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "3500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "4500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "5500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "Promaster 1500": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "Promaster 2500": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "Promaster 3500": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      }
    }
  },
  "ram-dodge": {
    label: "RAM / Dodge", collection: "ram-dodge",
    models: {
      "D200 Series 2wd": {
        years: [1962,1961],
        versions: ["Compatible"]
      },
      "D300 Series 2wd": {
        years: [1961],
        versions: ["Compatible"]
      },
      "Durango": {
        years: [2011],
        versions: ["Compatible"]
      },
      "Grand Cherokee": {
        years: [2011],
        versions: ["Compatible"]
      },
      "RAM 1500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1997,1996,1995,1994],
        versions: ["Tradesman Regular Cab","Tradesman Quad Cab","Tradesman Crew Cab","Big Horn Quad Cab","Big Horn Crew Cab","Laramie Quad Cab","Laramie Crew Cab","Rebel Crew Cab","TRX Crew Cab","Limited Crew Cab","Longhorn Crew Cab","Classic Big Horn","Classic Warlock","Power Wagon"]
      },
      "RAM 2500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2000,1995,1994],
        versions: ["Tradesman Regular Cab","Tradesman Mega Cab","Big Horn Crew Cab","Laramie Crew Cab","Power Wagon Crew Cab","Limited Crew Cab"]
      },
      "RAM 3500": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2000,1997,1996,1995,1994],
        versions: ["Tradesman Regular Cab","Big Horn Crew Cab","Laramie Crew Cab","Limited Crew Cab"]
      },
      "Scrambler": {
        years: [1976],
        versions: ["Compatible"]
      },
      "W100 Pickup 4wd": {
        years: [1961],
        versions: ["Compatible"]
      },
      "W200 Pickup 4wd": {
        years: [1961],
        versions: ["Compatible"]
      },
      "W250": {
        years: [1967,1966],
        versions: ["Compatible"]
      },
      "W300 Pickup 4wd": {
        years: [1961],
        versions: ["Compatible"]
      }
    }
  },
  "rolls": {
    label: "Rolls", collection: "rolls",
    models: {
      "Royce Camargue": {
        years: [1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Royce Corniche": {
        years: [1980,1979,1978,1977,1976,1975,1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "Royce Silver Shadow": {
        years: [1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966],
        versions: ["Compatible"]
      }
    }
  },
  "saab": {
    label: "Saab", collection: "saab",
    models: {
      "9 3": {
        years: [2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "9 5": {
        years: [2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "9 7x": {
        years: [2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "900": {
        years: [1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979],
        versions: ["Compatible"]
      },
      "9000": {
        years: [1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "99": {
        years: [1980,1979],
        versions: ["Compatible"]
      }
    }
  },
  "safari": {
    label: "Safari", collection: "safari",
    models: {
      "Cheetah": {
        years: [2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Zanzibar": {
        years: [2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      }
    }
  },
  "saturn": {
    label: "Saturn", collection: "saturn",
    models: {
      "Outlook": {
        years: [2010,2009,2008,2007],
        versions: ["Compatible"]
      }
    }
  },
  "scion": {
    label: "Scion", collection: "scion",
    models: {
      "Fr S": {
        years: [2016,2015,2014,2013],
        versions: ["Compatible"]
      }
    }
  },
  "smart": {
    label: "Smart", collection: "smart",
    models: {
      "Eq Fortwo": {
        years: [2019],
        versions: ["Compatible"]
      },
      "Fortwo": {
        years: [2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      }
    }
  },
  "spartan": {
    label: "Spartan", collection: "spartan",
    models: {
      "Motors Alpine": {
        years: [2003,2002,2001,2000,1999,1998,1997],
        versions: ["Compatible"]
      },
      "Motors EC2000": {
        years: [1996,1995,1994,1993],
        versions: ["Compatible"]
      },
      "Motors K2": {
        years: [2014,2013,2012,2011,2008,2007,2006,2005,2004,2002,2001,2000,1999,1998,1997],
        versions: ["Compatible"]
      },
      "Motors K3": {
        years: [2014,2013,2012,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "Motors Mountain Master": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993],
        versions: ["Compatible"]
      }
    }
  },
  "subaru": {
    label: "Subaru", collection: "subaru",
    models: {
      "Ascent": {
        years: [2025,2024,2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "Brz": {
        years: [2026,2025,2024,2023,2022,2020,2019,2018,2017,2016,2015,2014,2013],
        versions: ["Compatible"]
      },
      "Crosstrek": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Forester": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Impreza": {
        years: [2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "Legacy": {
        years: [2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "Outback": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Wrx": {
        years: [2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Wrx Sti": {
        years: [2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Xv Crosstrek": {
        years: [2015,2014,2013],
        versions: ["Compatible"]
      }
    }
  },
  "suzuki": {
    label: "Suzuki", collection: "suzuki",
    models: {
      "Equator": {
        years: [2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Grand Vitara": {
        years: [2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "Jimny": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018],
        versions: ["3 Puertas 4WD","5 Puertas 4WD","GL 4WD","GLX 4WD"]
      },
      "Samurai": {
        years: [1995,1994,1993,1992,1991,1990,1989,1988,1987,1986],
        versions: ["Base 4WD","JL 4WD","JS 4WD","JA 4WD"]
      },
      "Sidekick": {
        years: [1996,1995,1994,1993,1992,1991,1990,1989],
        versions: ["Compatible"]
      },
      "XL 7": {
        years: [2006,2005,2004,2003,2002],
        versions: ["Compatible"]
      }
    }
  },
  "tesla": {
    label: "Tesla", collection: "tesla",
    models: {
      "3": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "Cybertruck": {
        years: [2026,2025,2024],
        versions: ["Compatible"]
      },
      "Y": {
        years: [2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      }
    }
  },
  "toyota": {
    label: "Toyota", collection: "toyota",
    models: {
      "4Runner": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984],
        versions: ["SR5","TRD Sport","TRD Off-Road","Limited","TRD Pro","Trail","Nightshade","40th Anniversary"]
      },
      "86": {
        years: [2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "Celica": {
        years: [1993,1992,1991,1990],
        versions: ["Compatible"]
      },
      "Corolla": {
        years: [2008,2007,2006,2005,2004,2003,2002,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970],
        versions: ["Compatible"]
      },
      "FJ Cruiser": {
        years: [2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "GR86": {
        years: [2026,2025,2024,2023,2022],
        versions: ["Compatible"]
      },
      "Gr Supra": {
        years: [2026,2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Highlander": {
        years: [2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "Hilux": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005],
        versions: ["SR Regular Cab","SR Doble Cabina","SR5 Regular Cab","SR5 Doble Cabina","Invincible","GR Sport"]
      },
      "Land Cruiser": {
        years: [2026,2025,2024,2021,2020,2019,2018,2017,2016,2015,2014,2013,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962,1961,1960,1959],
        versions: ["Compatible"]
      },
      "MR2": {
        years: [1995,1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "Pickup": {
        years: [1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975,1974],
        versions: ["Compatible"]
      },
      "Prius": {
        years: [2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Rav4": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996],
        versions: ["Compatible"]
      },
      "Sequoia": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "T100": {
        years: [1998,1997,1996,1995,1994,1993],
        versions: ["Compatible"]
      },
      "Tacoma": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995],
        versions: ["SR Regular Cab","SR5 Regular Cab","SR Access Cab","SR5 Access Cab","TRD Sport Access Cab","TRD Off-Road Access Cab","Limited Access Cab","SR Double Cab","SR5 Double Cab","TRD Sport Double Cab","TRD Off-Road Double Cab","Limited Double Cab","TRD Pro Double Cab","Trail Double Cab","T/X Baja Double Cab","Wilderness Double Cab"]
      },
      "Tundra": {
        years: [2026,2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "Venza": {
        years: [2024,2023,2022,2021],
        versions: ["Compatible"]
      },
      "Yaris": {
        years: [2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "Yaris Ia": {
        years: [2018],
        versions: ["Compatible"]
      }
    }
  },
  "volkswagen": {
    label: "Volkswagen", collection: "volkswagen",
    models: {
      "411": {
        years: [1973,1972,1971],
        versions: ["Compatible"]
      },
      "412": {
        years: [1974,1973],
        versions: ["Compatible"]
      },
      "Arteon": {
        years: [2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "Atlas": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "Atlas Cross Sport": {
        years: [2025,2024,2023,2022,2021,2020],
        versions: ["Compatible"]
      },
      "Beetle": {
        years: [2019,2018,2017,2016,2015,2014,2013,2012,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962,1961,1960,1959,1958,1957,1956,1955,1954,1953,1952,1951,1950],
        versions: ["Compatible"]
      },
      "Cabrio": {
        years: [2002,2001,2000,1999,1998,1997,1996,1995],
        versions: ["Compatible"]
      },
      "Cabriolet": {
        years: [1993,1992,1991,1990,1989,1988,1987,1986,1985],
        versions: ["Compatible"]
      },
      "Cc": {
        years: [2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Corrado": {
        years: [1994,1993,1992,1991,1990],
        versions: ["Compatible"]
      },
      "Dasher": {
        years: [1981,1980,1979,1978,1977,1976,1975,1974],
        versions: ["Compatible"]
      },
      "E Golf": {
        years: [2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "Eos": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009,2008,2007],
        versions: ["Compatible"]
      },
      "Eurovan": {
        years: [2003,2002,2001,2000,1999,1997,1995,1993],
        versions: ["Compatible"]
      },
      "Fastback": {
        years: [1973,1972,1971,1970,1969,1968],
        versions: ["Compatible"]
      },
      "Fox": {
        years: [1989,1988,1987],
        versions: ["Compatible"]
      },
      "GTI": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006],
        versions: ["Compatible"]
      },
      "Golf": {
        years: [2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985],
        versions: ["Compatible"]
      },
      "Golf Alltrack": {
        years: [2019,2018,2017],
        versions: ["Compatible"]
      },
      "Golf R": {
        years: [2019,2018,2017,2016,2015,2013,2012],
        versions: ["Compatible"]
      },
      "Golf Sportwagen": {
        years: [2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "ID.4": {
        years: [2023,2022,2021],
        versions: ["Compatible"]
      },
      "Jetta": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980],
        versions: ["Compatible"]
      },
      "Karmann Ghia": {
        years: [1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962,1961,1960,1959,1958,1957,1956],
        versions: ["Compatible"]
      },
      "Passat": {
        years: [2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998,1997,1996,1995,1994,1993,1992,1991,1990],
        versions: ["Compatible"]
      },
      "Phaeton": {
        years: [2006,2005,2004],
        versions: ["Compatible"]
      },
      "Quantum": {
        years: [1988,1987,1986,1985,1984,1983,1982],
        versions: ["Compatible"]
      },
      "R32": {
        years: [2008,2004],
        versions: ["Compatible"]
      },
      "Rabbit": {
        years: [2009,2008,2007,2006,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Rabbit Convertible": {
        years: [1984,1983,1982,1981,1980],
        versions: ["Compatible"]
      },
      "Rabbit Pickup": {
        years: [1983,1982,1981,1980],
        versions: ["Compatible"]
      },
      "Scirocco": {
        years: [1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "Squareback": {
        years: [1973,1972,1971,1970,1969,1968,1967,1966],
        versions: ["Compatible"]
      },
      "Super Beetle": {
        years: [1980,1979,1978,1977,1976,1975,1974,1973,1972,1971],
        versions: ["Compatible"]
      },
      "Thing": {
        years: [1974,1973],
        versions: ["Compatible"]
      },
      "Tiguan": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010,2009],
        versions: ["Compatible"]
      },
      "Tiguan Limited": {
        years: [2018,2017],
        versions: ["Compatible"]
      },
      "Touareg": {
        years: [2017,2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "Transporter": {
        years: [1979,1978,1977,1976,1975,1974,1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962,1961,1960,1959,1958,1957,1956,1955],
        versions: ["Compatible"]
      },
      "Vanagon": {
        years: [1991,1990,1989,1988,1987,1986,1985,1984,1983,1982,1981,1980],
        versions: ["Compatible"]
      }
    }
  },
  "volvo": {
    label: "Volvo", collection: "volvo",
    models: {
      "122": {
        years: [1968,1967,1966,1965,1964,1963,1962,1961,1960,1959],
        versions: ["Compatible"]
      },
      "142": {
        years: [1974,1973,1972,1971,1970,1969,1968,1967],
        versions: ["Compatible"]
      },
      "144": {
        years: [1974,1973,1972,1971,1970,1969,1968,1967],
        versions: ["Compatible"]
      },
      "164": {
        years: [1975,1974,1973,1972,1971,1970,1969],
        versions: ["Compatible"]
      },
      "1800": {
        years: [1973,1972,1971,1970,1969,1968,1967,1966,1965,1964,1963,1962],
        versions: ["Compatible"]
      },
      "240": {
        years: [1993,1992,1991,1990],
        versions: ["Compatible"]
      },
      "242": {
        years: [1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "244": {
        years: [1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "245": {
        years: [1989,1988,1987,1986,1985,1984,1983,1982,1981,1980,1979,1978,1977,1976,1975],
        versions: ["Compatible"]
      },
      "262": {
        years: [1981,1980,1979,1978,1976],
        versions: ["Compatible"]
      },
      "264": {
        years: [1982,1981,1980,1979,1978,1977,1976],
        versions: ["Compatible"]
      },
      "265": {
        years: [1981,1980,1979,1978,1977,1976],
        versions: ["Compatible"]
      },
      "740": {
        years: [1992,1991,1990,1989,1988],
        versions: ["Compatible"]
      },
      "760": {
        years: [1990,1989,1988,1987,1986,1985,1984,1983],
        versions: ["Compatible"]
      },
      "780": {
        years: [1991,1990,1989,1988,1987],
        versions: ["Compatible"]
      },
      "850": {
        years: [1997,1996,1995,1994,1993],
        versions: ["Compatible"]
      },
      "940": {
        years: [1995,1994,1993,1992,1991],
        versions: ["Compatible"]
      },
      "960": {
        years: [1994,1993,1992],
        versions: ["Compatible"]
      },
      "C30": {
        years: [2013,2012,2011,2010,2009,2008],
        versions: ["Compatible"]
      },
      "C40 Recharge": {
        years: [2024,2023,2022],
        versions: ["Compatible"]
      },
      "C70": {
        years: [2013,2012,2011,2010,2009,2008,2007,2006,2004,2003,2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "EC40": {
        years: [2026],
        versions: ["Compatible"]
      },
      "EX40": {
        years: [2025],
        versions: ["Compatible"]
      },
      "S40": {
        years: [2011,2010,2009,2008,2007,2006,2005,2004],
        versions: ["Compatible"]
      },
      "S60": {
        years: [2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2009,2008,2007,2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "S70": {
        years: [2000,1999,1998],
        versions: ["Compatible"]
      },
      "S80": {
        years: [2016,2015,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "S90": {
        years: [2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "V40": {
        years: [2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "V50": {
        years: [2011,2010,2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      },
      "V60": {
        years: [2021,2020,2019,2018,2017,2016,2015],
        versions: ["Compatible"]
      },
      "V70": {
        years: [2010,2007,2006,2005,2004,2003,2002,2001,2000,1999,1998],
        versions: ["Compatible"]
      },
      "V90": {
        years: [2021,2020,2019,2018],
        versions: ["Compatible"]
      },
      "V90 Cross Country": {
        years: [2022,2021,2020,2019,2018,2017],
        versions: ["Compatible"]
      },
      "XC40": {
        years: [2025,2024,2023,2022,2021,2020,2019],
        versions: ["Compatible"]
      },
      "XC40 Recharge": {
        years: [2024,2023,2022,2021],
        versions: ["Compatible"]
      },
      "XC60": {
        years: [2023,2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "XC90": {
        years: [2022,2021,2020,2019,2018,2017,2016,2014,2013,2012,2011,2010,2009,2008,2007,2006,2005,2004,2003],
        versions: ["Compatible"]
      }
    }
  },
  "western": {
    label: "Western", collection: "western",
    models: {
      "Rv Alpine": {
        years: [2003,2002],
        versions: ["Compatible"]
      }
    }
  },
  "workhorse": {
    label: "Workhorse", collection: "workhorse",
    models: {
      "P30": {
        years: [2005,2004,2003,2002,2001,2000],
        versions: ["Compatible"]
      },
      "P32": {
        years: [2005,2004,2003,2002,2001,2000,1999],
        versions: ["Compatible"]
      },
      "W20": {
        years: [2009,2008,2007,2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "W22": {
        years: [2009,2008,2007,2006,2005,2004,2003,2002,2001],
        versions: ["Compatible"]
      },
      "W24": {
        years: [2009,2008,2007,2006,2005],
        versions: ["Compatible"]
      }
    }
  },
  "yamaha": {
    label: "Yamaha", collection: "yamaha",
    models: {
      "YZ250F": {
        years: [2018,2017,2016,2015,2014],
        versions: ["Compatible"]
      },
      "YZ450F": {
        years: [2018,2017,2016,2015,2014,2013,2012,2011,2010],
        versions: ["Compatible"]
      },
      "Yxz": {
        years: [2025,2024,2023,2022,2021,2020,2019,2018,2017,2016],
        versions: ["Compatible"]
      }
    }
  }
};
// ===== SELECTOR LOGIC =====
(function(){
  function vehicleSlug(value) {
    return (value || '').toString().toLowerCase().normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function normalizeJeepSelectorModels() {
    if (!window.X4DB || !window.X4DB.jeep || !window.X4DB.jeep.models) return;
    var models = window.X4DB.jeep.models;
    function descRange(start, end) {
      var years = [];
      for (var y = start; y >= end; y--) years.push(y);
      return years;
    }
    function uniqVersions(names, fallback) {
      var out = [];
      names.forEach(function(name){
        var data = models[name];
        if (!data || !data.versions) return;
        data.versions.forEach(function(version){
          if (version && out.indexOf(version) < 0) out.push(version);
        });
      });
      return out.length ? out : (fallback || ['Compatible']);
    }

    models['Gladiator'] = {
      years: descRange(2026, 2020),
      versions: uniqVersions(['Gladiator JT', 'Gladiator', 'Gladiador', 'Gladiador Mojave 206'], ['Sport','Sport S','Overland','Rubicon','Mojave','Willys','High Altitude'])
    };
    delete models['Gladiador'];
    delete models['Gladiador Mojave 206'];
    delete models['Gladiator JT'];

    models['Wrangler JL'] = {
      years: descRange(2026, 2018),
      versions: uniqVersions(['Wrangler JL'], ['Sport 2 Puertas','Sport Unlimited 4 Puertas','Sahara Unlimited 4 Puertas','Rubicon Unlimited 4 Puertas'])
    };
    models['Wrangler JK'] = {
      years: descRange(2018, 2007),
      versions: uniqVersions(['Wrangler JK'], ['Sport 2 Puertas','Sport Unlimited 4 Puertas','Sahara Unlimited 4 Puertas','Rubicon Unlimited 4 Puertas'])
    };
    models['Wrangler TJ'] = {
      years: descRange(2006, 1997),
      versions: uniqVersions(['Wrangler TJ', 'TJ'], ['Sport','Sahara','Rubicon','SE','Unlimited'])
    };
    models['Wrangler YJ'] = {
      years: descRange(1995, 1987),
      versions: ['Compatible']
    };
    delete models['Wrangler'];
    delete models['TJ'];
  }

  normalizeJeepSelectorModels();



  var UNSAFE_CANONICAL_FIT_TAGS = {"fit-1999-chevrolet-gmc-sierra-2500-hd":true,"fit-1999-chevrolet-gmc-sierra-3500-hd":true,"fit-1999-chevrolet-gmc-silverado-2500-hd":true,"fit-1999-chevrolet-gmc-silverado-3500-hd":true,"fit-2000-chevrolet-gmc-sierra-2500-hd":true,"fit-2000-chevrolet-gmc-sierra-3500-hd":true,"fit-2000-chevrolet-gmc-silverado-2500-hd":true,"fit-2000-chevrolet-gmc-silverado-3500-hd":true,"fit-2001-chevrolet-gmc-sierra-2500-hd":true,"fit-2001-chevrolet-gmc-sierra-3500-hd":true,"fit-2001-chevrolet-gmc-silverado-2500-hd":true,"fit-2001-chevrolet-gmc-silverado-3500-hd":true,"fit-2002-chevrolet-gmc-sierra-2500-hd":true,"fit-2002-chevrolet-gmc-sierra-3500-hd":true,"fit-2002-chevrolet-gmc-silverado-2500-hd":true,"fit-2002-chevrolet-gmc-silverado-3500-hd":true,"fit-2003-chevrolet-gmc-sierra-2500-hd":true,"fit-2003-chevrolet-gmc-sierra-3500-hd":true,"fit-2003-chevrolet-gmc-silverado-2500-hd":true,"fit-2003-chevrolet-gmc-silverado-3500-hd":true,"fit-2004-chevrolet-gmc-sierra-2500-hd":true,"fit-2004-chevrolet-gmc-sierra-3500-hd":true,"fit-2004-chevrolet-gmc-silverado-2500-hd":true,"fit-2004-chevrolet-gmc-silverado-3500-hd":true,"fit-2005-chevrolet-gmc-sierra-2500-hd":true,"fit-2005-chevrolet-gmc-sierra-3500-hd":true,"fit-2005-chevrolet-gmc-silverado-2500-hd":true,"fit-2005-chevrolet-gmc-silverado-3500-hd":true,"fit-2006-chevrolet-gmc-sierra-2500-hd":true,"fit-2006-chevrolet-gmc-sierra-3500-hd":true,"fit-2006-chevrolet-gmc-silverado-2500-hd":true,"fit-2006-chevrolet-gmc-silverado-3500-hd":true,"fit-2006-ram-dodge-ram-1500":true,"fit-2007-chevrolet-gmc-sierra-2500-hd":true,"fit-2007-chevrolet-gmc-sierra-3500-hd":true,"fit-2007-chevrolet-gmc-silverado-2500-hd":true,"fit-2007-chevrolet-gmc-silverado-3500-hd":true,"fit-2007-ram-dodge-ram-1500":true,"fit-2008-chevrolet-gmc-sierra-2500-hd":true,"fit-2008-chevrolet-gmc-sierra-3500-hd":true,"fit-2008-chevrolet-gmc-silverado-2500-hd":true,"fit-2008-chevrolet-gmc-silverado-3500-hd":true,"fit-2008-ram-dodge-ram-1500":true,"fit-2009-chevrolet-gmc-sierra-2500-hd":true,"fit-2009-chevrolet-gmc-sierra-3500-hd":true,"fit-2009-chevrolet-gmc-silverado-2500-hd":true,"fit-2009-chevrolet-gmc-silverado-3500-hd":true,"fit-2009-ram-dodge-ram-1500":true,"fit-2009-ram-dodge-ram-2500":true,"fit-2010-chevrolet-gmc-sierra-2500-hd":true,"fit-2010-chevrolet-gmc-sierra-3500-hd":true,"fit-2010-chevrolet-gmc-silverado-2500-hd":true,"fit-2010-chevrolet-gmc-silverado-3500-hd":true,"fit-2010-ram-dodge-ram-1500":true,"fit-2010-ram-dodge-ram-2500":true};

  function isUnsafeCanonicalFit(year, makeSlug, modelSlug) {
    return !!UNSAFE_CANONICAL_FIT_TAGS[['fit', year, makeSlug, modelSlug].join('-')];
  }

  function selectorHasVehicleYear(year, makeSlug, modelSlug) {
    var makeData = window.X4DB && window.X4DB[makeSlug];
    if (!makeData || !makeData.models) return false;
    var y = parseInt(year, 10);
    if (isNaN(y)) return false;
    return Object.keys(makeData.models).some(function(modelName){
      var model = makeData.models[modelName];
      return vehicleSlug(modelName) === modelSlug && model && Array.isArray(model.years) && model.years.indexOf(y) >= 0;
    });
  }

  function canonicalVehicleParts(year, make, model) {
    var y = vehicleSlug(year);
    var mk = vehicleSlug(make);
    var md = vehicleSlug(model);
    var candidate = null;

    if (mk === 'chevrolet-gmc') {
      if (md === 'silverado-1500') candidate = [y, 'chevrolet', 'silverado-1500'];
      else if (md === 'silverado-2500-hd') candidate = [y, 'chevrolet', 'silverado-2500-hd'];
      else if (md === 'silverado-3500-hd') candidate = [y, 'chevrolet', 'silverado-3500-hd'];
      else if (md === 'sierra-1500') candidate = [y, 'gmc', 'sierra-1500'];
      else if (md === 'sierra-2500-hd') candidate = [y, 'gmc', 'sierra-2500-hd'];
      else if (md === 'sierra-3500-hd') candidate = [y, 'gmc', 'sierra-3500-hd'];
      else if (md === 'colorado') candidate = [y, 'chevrolet', 'colorado'];
      else if (md === 'canyon') candidate = [y, 'gmc', 'canyon'];
      else if (md === 'tahoe') candidate = [y, 'chevrolet', 'tahoe'];
      else if (md === 'suburban') candidate = [y, 'chevrolet', 'suburban'];
      else if (md === 'yukon') candidate = [y, 'gmc', 'yukon'];
      else if (md === 'yukon-xl') candidate = [y, 'gmc', 'yukon-xl'];
    }

    if (mk === 'ram-dodge') {
      if (md === 'ram-1500') candidate = [y, 'ram', '1500'];
      else if (md === 'ram-2500') candidate = [y, 'ram', '2500'];
      else if (md === 'ram-3500') candidate = [y, 'ram', '3500'];
    }

    if (candidate && !isUnsafeCanonicalFit(y, mk, md) && selectorHasVehicleYear(y, candidate[1], candidate[2])) return candidate;
    return [y, mk, md];
  }

  function buildVehicleTags(year, make, model, version) {
    return year && make && model ? ['fit-' + canonicalVehicleParts(year, make, model).join('-')] : [];
  }

  function driveLabel(value) {
    if (value === '4wd') return '4x4';
    if (value === '2wd') return '4x2';
    return '';
  }

  function driveTag(value) {
    return value === '4wd' || value === '2wd' ? 'drive-' + value : '';
  }

  var WHEEL_CATEGORY_TAGS = [
    'cat-rines',
    'cat-llantas',
    'cat-espaciadores-de-rin',
    'cat-adaptadores-de-rin'
  ];

  function isWheelCategoryTag(tag) {
    return WHEEL_CATEGORY_TAGS.indexOf(tag) >= 0;
  }

  function wheelCollectionFromTags(tags) {
    return (tags || []).some(isWheelCategoryTag);
  }

  function hasWheelBoltTag(tags) {
    return (tags || []).some(function(tag){ return tag.indexOf('rin-barrenacion-') === 0; });
  }

  function yearNumber(vehicle) {
    var y = parseInt(vehicle && vehicle.year, 10);
    return isNaN(y) ? 0 : y;
  }

  function wheelBoltTagForVehicle(vehicle) {
    if (!vehicle || !vehicle.make || !vehicle.model) return '';
    var y = yearNumber(vehicle);
    var make = vehicleSlug(vehicle.make);
    var model = vehicleSlug(vehicle.model);
    var combined = make + ' ' + model;

    if (make === 'jeep') {
      if (/wrangler|gladiator/.test(model)) return 'rin-barrenacion-5x127';
      if (/grand-cherokee|commander/.test(model)) return 'rin-barrenacion-5x127';
      if (/cherokee|liberty|compass|renegade/.test(model)) return 'rin-barrenacion-5x110';
    }
    if (make === 'toyota') {
      if (/tacoma|4runner|fj-cruiser|hilux|sequoia|land-cruiser/.test(model)) return 'rin-barrenacion-6x139-7';
      if (/tundra/.test(model)) return y >= 2022 ? 'rin-barrenacion-6x139-7' : 'rin-barrenacion-5x150';
    }
    if (make === 'ford') {
      if (/f-150|f150|expedition/.test(model)) return y && y < 2004 ? 'rin-barrenacion-5x135' : 'rin-barrenacion-6x135';
      if (/bronco-sport|escape/.test(model)) return 'rin-barrenacion-5x108';
      if (/bronco|ranger/.test(model)) return 'rin-barrenacion-6x139-7';
      if (/f-250|f-350|super-duty/.test(model)) return 'rin-barrenacion-8x170';
    }
    if (make === 'chevrolet' || make === 'gmc' || make === 'chevrolet-gmc' || make === 'chevrolet gmc') {
      if (/colorado|canyon/.test(model)) return y >= 2023 ? 'rin-barrenacion-6x139-7' : 'rin-barrenacion-6x120';
      if (/silverado|sierra|tahoe|suburban|yukon|avalanche/.test(model)) {
        if (/2500|3500/.test(model)) return y >= 2011 ? 'rin-barrenacion-8x180' : 'rin-barrenacion-8x165-1';
        return 'rin-barrenacion-6x139-7';
      }
    }
    if (make === 'ram' || make === 'dodge' || make === 'ram-dodge' || make === 'ram dodge') {
      if (/2500|3500/.test(model)) return 'rin-barrenacion-8x165-1';
      if (/1500/.test(model)) return y >= 2019 ? 'rin-barrenacion-6x139-7' : 'rin-barrenacion-5x139-7';
      if (/dakota|durango/.test(model)) return 'rin-barrenacion-6x114-3';
    }
    if (make === 'nissan') {
      if (/frontier|xterra|pathfinder|titan|armada/.test(model)) return 'rin-barrenacion-6x139-7';
    }
    if (/can-am/.test(make) || /can am/.test(make) || /maverick|defender|commander/.test(combined)) return 'rin-barrenacion-4x137';
    if (/polaris/.test(make) || /rzr|ranger|general|xpedition/.test(combined)) return 'rin-barrenacion-4x156';
    if (/honda/.test(make) || /pioneer|talon/.test(combined)) return 'rin-barrenacion-4x137';
    if (/kawasaki/.test(make) || /teryx|mule/.test(combined)) return 'rin-barrenacion-4x137';
    if (/yamaha/.test(make) || /yxz|wolverine|viking/.test(combined)) return 'rin-barrenacion-4x110';
    if (/cfmoto/.test(make) || /segway/.test(make)) return 'rin-barrenacion-4x110';
    return '';
  }

  var STORAGE_KEY = 'x4:selectedVehicle';
  var STORAGE_DAYS = 180;

  function saveVehicleSelection(year, make, model, version, drive) {
    if (!year || !make || !model) return;
    var payload = {
      year: String(year),
      make: String(make),
      model: String(model),
      version: String(version || ''),
      drive: String(drive || ''),
      expiresAt: Date.now() + STORAGE_DAYS * 24 * 60 * 60 * 1000
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function getSavedVehicle() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.year || !data.make || !data.model || !data.expiresAt || Date.now() > data.expiresAt) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function clearSavedVehicle() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function vehicleQueryString(vehicle) {
    if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) return '';
    var out = new URLSearchParams();
    out.set('year', vehicle.year);
    out.set('make', vehicle.make);
    out.set('model', vehicle.model);
    if (vehicle.version) {
      out.set('version', vehicle.version);
      out.set('submodel', vehicle.version);
    }
    if (vehicle.drive) out.set('drive', vehicle.drive);
    return out.toString();
  }

  function vehicleTagPath(vehicle) {
    if (!vehicle) return '';
    var tags = buildVehicleTags(vehicle.year, vehicle.make, vehicle.model, vehicle.version);
    var dTag = driveTag(vehicle.drive);
    if (dTag) tags.push(dTag);
    return tags.join('+');
  }

  function stripSearchFitmentTerms(value) {
    return String(value || '')
      .replace(/\btag:(?:fit|drive)-[^\s]+/gi, '')
      .replace(/\b(?:fit|drive)-[a-z0-9-]+/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function vehicleAwareSearchUrl(term, vehicle) {
    var baseTerm = stripSearchFitmentTerms(term);
    var selected = vehicle || getSavedVehicle();
    if (!baseTerm || !selected) return '/search?q=' + encodeURIComponent(baseTerm || term || '');
    var tags = vehicleTagPath(selected).split('+').filter(Boolean);
    if (!tags.length) return '/search?q=' + encodeURIComponent(baseTerm);
    var query = baseTerm + ' ' + tags.map(function(tag){ return 'tag:' + tag; }).join(' ');
    return '/search?q=' + encodeURIComponent(query);
  }

  function bindVehicleAwareSearchForms() {
    document.querySelectorAll('form[action="/search"]').forEach(function(form){
      if (form.getAttribute('data-x4-vehicle-search-bound')) return;
      form.setAttribute('data-x4-vehicle-search-bound', '1');
      form.addEventListener('submit', function(ev){
        var vehicle = getSavedVehicle();
        if (!vehicle) return;
        var input = form.querySelector('input[name="q"]');
        var q = input ? input.value : '';
        if (!stripSearchFitmentTerms(q)) return;
        ev.preventDefault();
        window.location.href = vehicleAwareSearchUrl(q, vehicle);
      });
    });
  }

  function collectionTagParts(pathname) {
    var parts = pathname.split('/').filter(Boolean);
    if (parts[0] !== 'collections' || parts.length < 3) return [];
    return decodeURIComponent(parts.slice(2).join('/')).split('+').filter(Boolean);
  }

  function categoryTagFromHref(href) {
    var url = new URL(href, window.location.origin);
    return collectionTagParts(url.pathname).filter(function(tag){ return tag.indexOf('cat-') === 0; })[0] || '';
  }

  function urlWithVehicle(href, vehicle) {
    if (!vehicle) return href;
    var url = new URL(href, window.location.origin);
    var parts = url.pathname.split('/').filter(Boolean);
    if (parts[0] !== 'collections') return href;
    var tags = collectionTagParts(url.pathname).filter(function(tag){ return tag.indexOf('fit-') !== 0 && tag.indexOf('drive-') !== 0; });
    if (wheelCollectionFromTags(tags)) {
      var boltTag = wheelBoltTagForVehicle(vehicle);
      if (boltTag && !hasWheelBoltTag(tags)) tags.push(boltTag);
    } else {
      vehicleTagPath(vehicle).split('+').filter(Boolean).forEach(function(tag){
        if (tags.indexOf(tag) < 0) tags.push(tag);
      });
    }
    url.pathname = '/collections/' + (parts[1] || 'all') + (tags.length ? '/' + tags.join('+') : '');
    var qs = vehicleQueryString(vehicle);
    if (qs) {
      var vehicleParams = new URLSearchParams(qs);
      vehicleParams.forEach(function(value, key){ url.searchParams.set(key, value); });
    }
    return url.pathname + url.search + url.hash;
  }

  function syncWheelCollectionToSavedVehicle() {
    var vehicle = getSavedVehicle();
    if (!vehicle || window.location.pathname.indexOf('/collections/') !== 0) return;
    var url = new URL(window.location.href);
    var parts = url.pathname.split('/').filter(Boolean);
    if (parts[0] !== 'collections') return;
    var tags = collectionTagParts(url.pathname);
    if (!wheelCollectionFromTags(tags)) return;
    var boltTag = wheelBoltTagForVehicle(vehicle);
    if (!boltTag) return;
    var cleaned = tags.filter(function(tag){
      return tag.indexOf('fit-') !== 0 && tag.indexOf('drive-') !== 0;
    });
    if (!hasWheelBoltTag(cleaned)) cleaned.push(boltTag);
    var changed = cleaned.join('+') !== tags.join('+');
    url.pathname = '/collections/' + (parts[1] || 'all') + (cleaned.length ? '/' + cleaned.join('+') : '');
    var qs = vehicleQueryString(vehicle);
    if (qs) {
      var vehicleParams = new URLSearchParams(qs);
      vehicleParams.forEach(function(value, key){ url.searchParams.set(key, value); });
    }
    if (changed) window.location.replace(url.pathname + url.search + url.hash);
  }

  function urlWithoutVehicle(href) {
    var url = new URL(href, window.location.origin);
    var parts = url.pathname.split('/').filter(Boolean);
    if (parts[0] === 'collections' && parts.length >= 3) {
      var tags = collectionTagParts(url.pathname).filter(function(tag){ return tag.indexOf('fit-') !== 0 && tag.indexOf('drive-') !== 0; });
      url.pathname = '/collections/' + (parts[1] || 'all') + (tags.length ? '/' + tags.join('+') : '');
    }
    ['year','make','model','version','submodel','drive'].forEach(function(key){ url.searchParams.delete(key); });
    return url.pathname + url.search + url.hash;
  }

  function plainVehicleLabel(vehicle) {
    if (!vehicle) return '';
    var make = (window.X4DB[vehicle.make] && window.X4DB[vehicle.make].label) || vehicle.make;
    return [vehicle.year, make, vehicle.model, vehicle.version, driveLabel(vehicle.drive)].filter(Boolean).join(' · ');
  }

  // Edit this list to change the Garage category names, order, or collection tags.
  var garageCategories = [
    ['Amortiguadores','cat-amortiguadores'],['Estabilizadores','cat-estabilizadores'],
    ['Suspensiones','cat-suspensiones'],['Nivelación','cat-leveling'],
    ['Winches','cat-winches'],['Candados de cofre','cat-candados-cofre'],
    ['Llantas','cat-llantas'],['Defensas','cat-defensa'],
    ['Diferencial','cat-diferencial'],['Partes de suspensión','cat-partes-de-suspension'],
    ['Barras de luz','cat-barras-luz'],['Faros auxiliares','cat-faros-auxiliares'],
    ['Recuperación','cat-recuperacion'],['Tapas de caja','cat-tapas-de-caja'],
    ['Espaciadores de rin','cat-espaciadores-de-rin'],['Adaptadores de rin','cat-adaptadores-de-rin'],
    ['Estribos','cat-estribos'],['Barra cardán','cat-barra-cardan'],
    ['Portallantas','cat-portallantas'],['Líneas de freno','cat-lineas-de-freno'],
    ['Brazos de control','cat-brazos-de-control'],['Inner Fender','cat-inner-fender'],
    ['Horquillas','cat-horquillas'],['Exterior','cat-exterior'],
    ['Herramientas','cat-herramientas'],['Performance','cat-performance'],
    ['Dirección','cat-direccion'],['Rines','cat-rines'],
    ['Polveras','cat-polveras'],['Interior','cat-interior'],
    ['Merch','cat-merch'],['Bolsas de aire','cat-bolsas-de-aire']
  ];
  // Edit this list to change Garage brands; empty vehicle routes stay hidden.
  var garageBrands = [
    ['Bilstein','brand-bilstein'],['Rough Country','brand-rough-country'],['Fox Shocks','brand-fox-shocks'],
    ['ARB / Old Man Emu','brand-arb-old-man-emu'],['Baja Designs','brand-baja-designs'],
    ['Warn','brand-warn'],['Fuel Off-Road','brand-fuel-off-road'],
    ['Artec Industries','brand-artec-industries'],['Rigid Industries','brand-rigid-industries'],
    ['Rubicon Express','brand-rubicon-express'],['Xtreme 4x4','brand-xtreme-4x4']
  ];
  var garageRequestId = 0;

  function garageCollectionUrl(tags, vehicle) {
    var href;
    if (wheelCollectionFromTags(tags)) {
      href = urlWithVehicle('/collections/all/' + tags.join('+'), vehicle);
    } else {
      var allTags = vehicleTagPath(vehicle).split('+').filter(Boolean).concat(tags);
      var query = vehicleQueryString(vehicle);
      href = '/collections/all/' + allTags.join('+') + (query ? '?' + query : '');
    }
    var parsed = new URL(href, window.location.origin);
    parsed.pathname = '/collections/all/' + collectionTagParts(parsed.pathname).sort().join('+');
    return parsed.pathname + parsed.search;
  }

  function garageCollectionSummary(url) {
    var parsed = new URL(url, window.location.origin);
    parsed.search = '?view=x4menu';
    var key = 'x4menu:' + parsed.pathname;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.at < 15 * 60 * 1000) return Promise.resolve(cached.data);
    } catch (e) {}
    return fetch(parsed.pathname + parsed.search, {credentials:'same-origin'})
      .then(function(response){ if (!response.ok) throw new Error('collection ' + response.status); return response.json(); })
      .then(function(data){
        if (typeof data.count !== 'number') throw new Error('invalid collection summary');
        try { sessionStorage.setItem(key, JSON.stringify({at:Date.now(),data:data})); } catch (e) {}
        return data;
      });
  }

  function garageTile(label, href, imageUrl, brand) {
    var link = document.createElement('a');
    link.href = href;
    link.setAttribute('data-x4-no-vehicle-link','');
    link.className = brand ? 'x4-garage-brand' : 'x4-garage-category';
    if (imageUrl && !brand) {
      var image = document.createElement('img');
      image.src = imageUrl;
      image.alt = '';
      image.loading = 'lazy';
      link.appendChild(image);
    } else if (!brand) {
      var fallback = document.createElement('span');
      fallback.className = 'x4-garage-category-placeholder';
      fallback.setAttribute('aria-hidden', 'true');
      fallback.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4l-6.2 6.2a2 2 0 0 0 2.8 2.8l6.2-6.2a4 4 0 0 0 5.4-5.4l-2.9 2.9-2.8-2.8z"/></svg>';
      link.appendChild(fallback);
    }
    var name = document.createElement('span');
    name.textContent = label;
    link.appendChild(name);
    return link;
  }

  function garageSkeleton(target, count, brand) {
    for (var i = 0; i < count; i++) {
      var item = document.createElement('span');
      item.className = brand ? 'x4-garage-skeleton x4-garage-skeleton-brand' : 'x4-garage-skeleton';
      item.setAttribute('aria-hidden', 'true');
      target.appendChild(item);
    }
  }

  function showGarageVehiclePanel(vehicle) {
    var modal = document.getElementById('x4-garage-modal');
    if (!modal || !vehicle) return;
    var selector = modal.querySelector('.x4-garage-selector');
    var panel = modal.querySelector('.x4-garage-vehicle-panel');
    var title = modal.querySelector('#x4-garage-title');
    if (!panel || !selector) return;
    selector.hidden = true;
    panel.hidden = false;
    title.textContent = plainVehicleLabel(vehicle);
    var all = panel.querySelector('.x4-garage-all');
    all.href = garageCollectionUrl([], vehicle);
    var categories = panel.querySelector('.x4-garage-category-grid');
    var brands = panel.querySelector('.x4-garage-brand-row');
    categories.replaceChildren();
    brands.replaceChildren();
    garageSkeleton(categories, 8, false);
    garageSkeleton(brands, 5, true);
    panel.querySelector('.x4-garage-category-status').textContent = 'Cargando categorías…';
    panel.querySelector('.x4-garage-brand-status').textContent = '';
    panel.dataset.categoriesReady = 'false';
    panel.dataset.brandsReady = 'false';
    var currentCategory = collectionTagParts(window.location.pathname).filter(function(tag){ return tag.indexOf('cat-') === 0; })[0] || '';
    var requestId = ++garageRequestId;
    var started = performance.now();
    window.x4GarageTiming = {started:started, categoryRequests:0, brandRequests:0};
    function loadGroup(items, brand) {
      var target = brand ? brands : categories;
      var status = panel.querySelector(brand ? '.x4-garage-brand-status' : '.x4-garage-category-status');
      var next = 0;
      var failures = 0;
      function worker() {
        if (next >= items.length || requestId !== garageRequestId) return Promise.resolve();
        var order = next++;
        var item = items[order];
        var tags = brand && currentCategory ? [currentCategory,item[1]] : [item[1]];
        var href = garageCollectionUrl(tags, vehicle);
        window.x4GarageTiming[brand ? 'brandRequests' : 'categoryRequests']++;
        return garageCollectionSummary(href).then(function(summary){
          if (requestId !== garageRequestId || summary.count < 1) return;
          target.querySelectorAll('.x4-garage-skeleton').forEach(function(skeleton){ skeleton.remove(); });
          var tile = garageTile(item[0], href, summary.image, brand);
          tile.dataset.order = String(order);
          target.appendChild(tile);
          Array.prototype.slice.call(target.children).sort(function(a,b){
            return Number(a.dataset.order) - Number(b.dataset.order);
          }).forEach(function(child){ target.appendChild(child); });
          status.textContent = '';
        }).catch(function(){ failures++; }).then(worker);
      }
      return Promise.all([worker(),worker(),worker(),worker()]).then(function(){
        if (requestId !== garageRequestId) return;
        target.querySelectorAll('.x4-garage-skeleton').forEach(function(skeleton){ skeleton.remove(); });
        if (!target.children.length) status.textContent = failures ? (brand ? 'No se pudieron cargar las marcas.' : 'No se pudieron cargar las categorías.') : (brand ? 'No hay marcas para este vehículo.' : 'No hay categorías para este vehículo.');
        panel.dataset[brand ? 'brandsReady' : 'categoriesReady'] = 'true';
        window.x4GarageTiming[brand ? 'brandsMs' : 'categoriesMs'] = Math.round(performance.now() - started);
      });
    }
    loadGroup(garageCategories, false).then(function(){
      if (requestId !== garageRequestId) return;
      panel.querySelector('.x4-garage-brand-status').textContent = 'Cargando marcas…';
      return loadGroup(garageBrands, true);
    });
  }

  function showGarageSelectorForm() {
    var modal = document.getElementById('x4-garage-modal');
    if (!modal) return;
    garageRequestId++;
    modal.querySelector('.x4-garage-selector').hidden = false;
    modal.querySelector('.x4-garage-vehicle-panel').hidden = true;
    modal.querySelector('#x4-garage-title').textContent = 'Elige tu vehículo';
  }

  function injectSavedVehicleBar() {
    var vehicle = getSavedVehicle();
    var old = document.getElementById('x4-saved-vehicle-bar');
    if (old) old.remove();
    if (!vehicle) return;
    var header = document.getElementById('header');
    var bar = document.createElement('div');
    bar.id = 'x4-saved-vehicle-bar';
    bar.className = 'x4-saved-vehicle-bar';
    bar.innerHTML = '<div class="x4-saved-vehicle-inner"><span class="x4-saved-vehicle-icon" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 13h18l-2 6H5l-2-6z"></path><path d="M7 13l2-5h6l2 5"></path><circle cx="7" cy="20" r="1"></circle><circle cx="17" cy="20" r="1"></circle></svg></span><strong></strong><button type="button" class="x4-change-vehicle" data-x4-open-garage>Categorías para tu vehículo</button><button type="button" class="x4-clear-vehicle" aria-label="Quitar vehiculo">×</button></div>';
    bar.querySelector('strong').textContent = plainVehicleLabel(vehicle);
    bar.querySelector('[data-x4-open-garage]').addEventListener('click', function(){
      openGarageSelector();
    });
    bar.querySelector('.x4-clear-vehicle').addEventListener('click', function(){
      clearSavedVehicle();
      if (window.location.pathname.indexOf('/collections/') === 0) {
        window.location.href = urlWithoutVehicle(window.location.href) || '/collections/all';
      } else {
        injectSavedVehicleBar();
      }
    });
    if (header && header.parentNode) {
      header.parentNode.insertBefore(bar, header.nextSibling);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
  }

  function injectGarageSelector() {
    var button = document.getElementById('x4-garage-button');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.id = 'x4-garage-button';
      button.className = 'x4-garage-button';
      button.setAttribute('aria-label', 'Abrir selector de vehiculo');
      button.innerHTML = '<span aria-hidden="true"><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 21V8l9-5 9 5v13"></path><path d="M7 21v-8h10v8"></path><path d="M9 17h6"></path></svg></span><strong>Garage</strong><em></em>';
      button.addEventListener('click', openGarageSelector);
      document.body.appendChild(button);
    }

    var modal = document.getElementById('x4-garage-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'x4-garage-modal';
      modal.className = 'x4-garage-modal';
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML = '<div class="x4-garage-backdrop" data-x4-close-garage></div><div class="x4-garage-dialog" role="dialog" aria-modal="true" aria-labelledby="x4-garage-title"><button type="button" class="x4-garage-close" data-x4-close-garage aria-label="Cerrar selector">×</button><div class="x4-garage-head"><span>Garage</span><h2 id="x4-garage-title">Elige tu vehículo</h2></div><div class="ymm x4-garage-selector" data-ymm-selector="garage"><div class="ymm-inner"><div class="ymm-row ymm-row--5"><div class="ymm-group"><label class="ymm-lbl">Año</label><select class="ymm-select" id="garage-year"></select></div><div class="ymm-group"><label class="ymm-lbl">Marca</label><select class="ymm-select" id="garage-make" disabled></select></div><div class="ymm-group"><label class="ymm-lbl">Modelo</label><select class="ymm-select" id="garage-model" disabled></select></div><div class="ymm-group"><label class="ymm-lbl">Submodelo</label><select class="ymm-select" id="garage-version" disabled></select></div><div class="ymm-group"><label class="ymm-lbl">Tracción</label><select class="ymm-select" id="garage-drive" disabled></select></div></div><button class="ymm-btn" id="garage-search">Buscar piezas compatibles</button><button class="x4-garage-clear" type="button">Ver catálogo sin filtrar</button></div></div><div class="x4-garage-vehicle-panel" hidden><div class="x4-garage-vehicle-actions"><button type="button" class="x4-garage-change">Cambiar vehículo</button><a class="x4-garage-all" data-x4-no-vehicle-link href="/collections/all">Ver todas las piezas</a></div><h3>Categorías</h3><p class="x4-garage-category-status" role="status"></p><div class="x4-garage-category-grid"></div><h3>Marcas</h3><p class="x4-garage-brand-status" role="status"></p><div class="x4-garage-brand-row"></div></div></div>';
      modal.querySelectorAll('[data-x4-close-garage]').forEach(function(el){
        el.addEventListener('click', closeGarageSelector);
      });
      modal.querySelector('.x4-garage-clear').addEventListener('click', function(){
        clearSavedVehicle();
        window.location.href = window.location.pathname.indexOf('/collections/') === 0 ? urlWithoutVehicle(window.location.href) : '/collections/all';
      });
      modal.querySelector('.x4-garage-change').addEventListener('click', showGarageSelectorForm);
      document.body.appendChild(modal);
      initSelector('garage');
    }
    refreshGarageButtonLabel();
  }

  function refreshGarageButtonLabel() {
    var button = document.getElementById('x4-garage-button');
    if (!button) return;
    var vehicle = getSavedVehicle();
    var label = button.querySelector('em');
    if (label) label.textContent = vehicle ? plainVehicleLabel(vehicle) : 'Elige tu vehiculo';
  }

  function openGarageSelector() {
    var modal = document.getElementById('x4-garage-modal');
    if (!modal) {
      injectGarageSelector();
      modal = document.getElementById('x4-garage-modal');
    }
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('x4-garage-open');
    var vehicle = getSavedVehicle();
    if (vehicle) showGarageVehiclePanel(vehicle);
    else showGarageSelectorForm();
    var first = modal.querySelector(vehicle ? '.x4-garage-all' : 'select');
    if (first) setTimeout(function(){ first.focus(); }, 30);
  }

  function closeGarageSelector() {
    var modal = document.getElementById('x4-garage-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('x4-garage-open');
  }

  function rewriteGlobalCollectionLinks() {
    var vehicle = getSavedVehicle();
    if (!vehicle) return;
    document.querySelectorAll('a[href^="/collections/"]').forEach(function(a){
      if (a.hasAttribute('data-x4-no-vehicle-link')) return;
      var href = a.getAttribute('href');
      if (!href || href.indexOf('/collections/ofertas-y-promociones') === 0) return;
      a.setAttribute('href', urlWithVehicle(href, vehicle));
    });
  }

  function bindVehicleSelectorLinks() {
    document.querySelectorAll('a[href="/#selector-vehiculo"], a[href="#selector-vehiculo"]').forEach(function(a){
      if (a.getAttribute('data-x4-garage-bound')) return;
      a.setAttribute('data-x4-garage-bound', '1');
      a.addEventListener('click', function(ev){
        ev.preventDefault();
        openGarageSelector();
      });
    });
  }

  function initSelector(prefix) {
    var selYear = document.getElementById(prefix+'-year');
    var selMake = document.getElementById(prefix+'-make');
    var selModel = document.getElementById(prefix+'-model');
    var selVersion = document.getElementById(prefix+'-version');
    var selDrive = document.getElementById(prefix+'-drive');
    var selCategory = document.getElementById(prefix+'-category');
    var btnSearch = document.getElementById(prefix+'-search');
    if (!selYear || !selMake || !selModel || !selVersion || selYear.getAttribute('data-x4-ready')) return;
    selYear.setAttribute('data-x4-ready', '1');

    if (!selDrive) {
      var versionLabel = selVersion.closest ? selVersion.closest('label,.ymm-group') : null;
      if (versionLabel && versionLabel.parentNode) {
        var holder = document.createElement(versionLabel.tagName && versionLabel.tagName.toLowerCase() === 'label' ? 'label' : 'div');
        holder.className = ((versionLabel.className || 'ymm-group') + ' x4-drive-field').trim();
        if (holder.tagName.toLowerCase() === 'label') {
          holder.innerHTML = '<span class="ymm-lbl">Tracción</span><select class="ymm-select" id="'+prefix+'-drive" disabled><option value="">Seleccionar</option></select>';
        } else {
          holder.innerHTML = '<label class="ymm-lbl">Tracción</label><select class="ymm-select" id="'+prefix+'-drive" disabled><option value="">Seleccionar</option></select>';
        }
        versionLabel.parentNode.insertBefore(holder, versionLabel.nextSibling);
        selDrive = document.getElementById(prefix+'-drive');
      }
    }

    function reset(sel, txt) {
      if (!sel) return;
      sel.innerHTML='<option value="">'+txt+'</option>';
      sel.disabled=true;
    }

    // Populate years (sorted descending, unique across all makes)
    selYear.innerHTML = '<option value="">Seleccionar</option>';
    var allYears = new Set();
    Object.values(window.X4DB).forEach(function(mk){
      Object.values(mk.models).forEach(function(m){ m.years.forEach(function(y){ allYears.add(y); }); });
    });
    Array.from(allYears).sort(function(a,b){return b-a;}).forEach(function(y){
      var o = document.createElement('option'); o.value=y; o.text=y; selYear.appendChild(o);
    });

    selYear.disabled = false;
    reset(selMake,'Seleccionar');
    reset(selModel,'Seleccionar');
    reset(selVersion,'Seleccionar');
    reset(selDrive,'Seleccionar');
    if(btnSearch) btnSearch.disabled=true;

    selYear.addEventListener('change', function(){
      var yr = parseInt(this.value);
      reset(selMake,'Seleccionar'); reset(selModel,'Seleccionar'); reset(selVersion,'Seleccionar'); reset(selDrive,'Seleccionar');
      if(btnSearch) btnSearch.disabled=true;
      if(!yr) return;
      Object.keys(window.X4DB).forEach(function(mk){
        var data = window.X4DB[mk];
        var hasModel = Object.values(data.models).some(function(m){ return m.years.indexOf(yr)>=0; });
        if(hasModel){ var o=document.createElement('option'); o.value=mk; o.text=data.label; selMake.appendChild(o); }
      });
      selMake.disabled=false;
    });

    selMake.addEventListener('change', function(){
      var yr = parseInt(selYear.value);
      var mk = this.value;
      reset(selModel,'Seleccionar'); reset(selVersion,'Seleccionar'); reset(selDrive,'Seleccionar');
      if(btnSearch) btnSearch.disabled=true;
      if(!yr||!mk||!window.X4DB[mk]) return;
      Object.keys(window.X4DB[mk].models).forEach(function(name){
        var m = window.X4DB[mk].models[name];
        if(m.years.indexOf(yr)>=0){ var o=document.createElement('option'); o.value=name; o.text=name; selModel.appendChild(o); }
      });
      selModel.disabled=false;
    });

    selModel.addEventListener('change', function(){
      var mk = selMake.value;
      var mod = this.value;
      reset(selVersion,'Seleccionar');
      reset(selDrive,'Seleccionar');
      if(btnSearch) btnSearch.disabled=true;
      if(!mk||!mod||!window.X4DB[mk]||!window.X4DB[mk].models[mod]) return;
      window.X4DB[mk].models[mod].versions.forEach(function(v){
        var o=document.createElement('option'); o.value=v; o.text=v; selVersion.appendChild(o);
      });
      selVersion.disabled=false;
    });

    selVersion.addEventListener('change', function(){
      reset(selDrive,'Seleccionar');
      if (this.value && selDrive) {
        [['4wd','4x4'], ['2wd','4x2']].forEach(function(pair){
          var o = document.createElement('option'); o.value = pair[0]; o.text = pair[1]; selDrive.appendChild(o);
        });
        selDrive.disabled = false;
      }
      if(btnSearch) btnSearch.disabled = !(this.value && selDrive && selDrive.value);
    });

    if (selDrive) {
      selDrive.addEventListener('change', function(){
        if(btnSearch) btnSearch.disabled = !(selVersion.value && this.value);
      });
    }

    if(btnSearch) {
      btnSearch.addEventListener('click', function(){
        var yr = selYear.value;
        var mk = selMake.value;
        var mod = selModel.value;
        var ver = selVersion.value;
        var drive = selDrive ? selDrive.value : '';
        if(!yr || !mk || !mod || !ver || !drive){ alert('Selecciona año, marca, modelo, submodelo y tracción'); return; }
        var cat = selCategory && selCategory.value && selCategory.value !== 'all' ? selCategory.value : '';
        saveVehicleSelection(yr, mk, mod, ver, drive);
        var tagList = buildVehicleTags(yr, mk, mod, ver);
        tagList.push(driveTag(drive));
        var tags = tagList.filter(Boolean).join('+');
        var combinedTags = cat ? cat + '+' + tags : tags;
        var url = '/collections/all/'+combinedTags+'?year='+encodeURIComponent(yr)+'&make='+encodeURIComponent(mk)+'&model='+encodeURIComponent(mod)+'&version='+encodeURIComponent(ver)+'&submodel='+encodeURIComponent(ver)+'&drive='+encodeURIComponent(drive);
        if (prefix === 'garage') {
          injectSavedVehicleBar();
          refreshGarageButtonLabel();
          showGarageVehiclePanel(getSavedVehicle());
        } else {
          openGarageSelector();
        }
      });
    }
  }

  window.x4InitSelector = initSelector;
  window.x4VehicleTags = buildVehicleTags;
  window.x4SaveVehicle = saveVehicleSelection;
  window.x4GetSavedVehicle = getSavedVehicle;
  window.x4ClearSavedVehicle = clearSavedVehicle;
  window.x4VehicleQueryString = vehicleQueryString;
  window.x4VehicleTagPath = vehicleTagPath;
  window.x4VehicleAwareSearchUrl = vehicleAwareSearchUrl;
  window.x4WheelBoltTagForVehicle = wheelBoltTagForVehicle;
  window.x4UrlWithVehicle = urlWithVehicle;
  window.x4PlainVehicleLabel = plainVehicleLabel;
  window.x4OpenGarageSelector = openGarageSelector;

  document.addEventListener('DOMContentLoaded', function(){
    // Init all selectors found on the page
    ['hero','h','col','list','ymm'].forEach(function(p){
      initSelector(p);
    });
    injectSavedVehicleBar();
    injectGarageSelector();
    bindVehicleSelectorLinks();
    bindVehicleAwareSearchForms();
    rewriteGlobalCollectionLinks();
    syncWheelCollectionToSavedVehicle();
  });
})();
